// AUTO-STRUCTURED locale file. Keys mirror en.ts exactly; missing keys fall back
// to English (see src/i18n/index.ts). Placeholders use {name} interpolation.
export default {
 modelAuthorization: {
  "title": "連接 ChatGPT",
  "description": "使用你的 ChatGPT 帳號執行個人雲端任務。",
  "name": "連接名稱",
  "enterCode": "在 ChatGPT 授權頁面輸入以下代碼：",
  "openProvider": "開啟 ChatGPT 授權頁面",
  "enableDevice": "請先在 ChatGPT 安全設定中啟用裝置代碼登入。完成授權後，此頁會自動檢查結果。",
  "chooseModels": "已連接。關閉此視窗，瀏覽即時模型目錄並選擇要使用的模型。",
  "cancel": "取消授權",
  "retry": "重新檢查",
  "reauthorize": "重新授權",
  "done": "完成",
  "connect": "連接 ChatGPT",
  "failed": "授權失敗，請重試。",
  "state": {
    "pending": "等待授權",
    "ready": "已連接",
    "expired": "授權代碼已過期，請重新開始。",
    "requires_reauth": "需要授權"
  }
},
  cloudRemoteInspector: {
    noModels: "此裝置沒有可用模型。請在裝置端設定提供方，或新增可用的個人雲端模型。",
    modelSettings: "模型設定",
    fullPreview: "此處顯示相對於目標分支的全部改動，包括已提交和未提交的內容。僅交付你勾選的檔案。",
    "createDraft": "建立草稿 Pull request",
    "deliveryUpgrade": "升級此裝置上的 jcode 後，可交付已審閱的改動。",
    "close": "關閉",
    "delivering": "正在交付…",
    "publishDraft": "推送分支並建立草稿",
    "delivered": "草稿 Pull request 已建立。",
    "openPR": "開啟 Pull request",
    "deliveryExplanation": "勾選已審閱的檔案。操作會使用裝置上的 Git 和 GitHub CLI 憑證推送獨立分支；目前分支、檔案和暫存區會保留。",
    "defaultBase": "目標：儲存庫預設分支",
    "prTitle": "Pull request 標題",
    "prBody": "說明（選填）",
    "selectFiles": "選擇要交付的檔案",
    "viewPatch": "審閱 diff",

    "title": "任務資訊",
    "changes": "改動",
    "details": "詳細資訊",
    "upgradeRequired": "升級此裝置上的 jcode 後，即可查看工作區改動。",
    "setup": "裝置連線指南",
    "files": "{count} 個檔案",
    "refresh": "重新整理",
    "offline": "裝置已離線，重新連線後可重新整理改動。",
    "workspaceChanges": "工作區相對於 HEAD 的目前改動，包含任務開始前已有的改動。",
    "clean": "工作區沒有未提交的改動。",
    "truncated": "改動超過顯示上限，目前預覽不完整。請在裝置上檢查完整改動。",
    "updated": "更新於 {time}",
    "device": "裝置",
    "workspace": "工作區",
    "branch": "分支",
    "model": "模型",
    "connection": "連線狀態",
    "online": "線上",
    "offlineLabel": "離線",
    "version": "jcode 版本",
    "openDevice": "開啟裝置",
    "binary": "二進位檔案，請在裝置上查看內容。"
},
  cloudRefresh: {
    "noGitProviders": "尚未設定 Git 登入提供方，請聯絡管理員設定提供方連線。",
    "sessionNotFound": "找不到此對話",
    "addAttachments": "新增檔案",
    "uploading": "上傳中…",
    "attachmentReady": "已新增",
    "attachmentExpired": "已過期，請重新上傳",
    "uploadFailed": "上傳失敗，請重試或移除檔案。若附件儲存空間無法使用，請聯絡管理員。",
    "attachmentLimits": "最多 10 個檔案，單個不超過 25 MiB，總計不超過 100 MiB；不支援空檔案。",
    "removeAttachment": "移除 {name}",

    "navigationFailed": "無法載入最近工作。",
    "accountRequired": "請使用個人帳號登入，以管理這些設定。",
    "noMatchingDevices": "沒有符合的裝置",
    "personalModelsEmpty": "在模型設定中新增個人提供方，或請管理員授權模型。",

    "personalModelsDescription": "個人模型可用於你有權存取的儲存庫。",
    "updateCredentials": "更新憑證",
    "enable": "啟用",
    "disable": "停用",
    "deleteModel": "刪除 {name}",
    "deleteModelConfirm": "確認刪除模型 {name}？",
    "availableModels": "可用於任務的模型",

    "defaultModel": "預設模型",
    "automaticModel": "自動選擇可用模型",
    "unavailableModel": "模型無法使用，請重新選擇",
    "defaultPermission": "預設執行權限",
    "askApproval": "操作前審批",
    "fullAccess": "完整存取",
    "planMode": "僅規劃",
    "defaultEffort": "預設推理強度",
    "effort_auto": "自動",
    "effort_low": "低",
    "effort_medium": "中",
    "effort_high": "高",
    "light": "淺色",
    "dark": "深色",
    "sendKey": "訊息傳送方式",

    "recentRepositories": "最近儲存庫",
    "remoteDevices": "遠端裝置",
    "recentConversations": "最近對話",
    "allRepositories": "所有儲存庫",
    "personalWorkspace": "個人工作區",
    "homeTitle": "下一步，想做什麼？",
    "homeDescription": "從一個想法開始，讓 jcode 幫你推進。",
    "searchTasks": "搜尋任務",
    "all": "全部",
    "active": "進行中",
    "attention": "需關注",
    "completed": "已完成",
    "noMatch": "沒有符合的任務",
    "noMatchDescription": "試試其他關鍵字，或清除篩選條件。",
    "clearFilters": "清除篩選",
    "connectDevice": "連接裝置",
    "searchDevices": "搜尋裝置",
    "devicesTitle": "你的裝置，隨時接著工作",
    "devicesDescription": "在已登入 jcode 的裝置上，開啟工作區並繼續對話。",
    "noDevices": "尚未連接裝置",
    "noDevicesDescription": "連接裝置上的 jcode，開始遠端工作。",
    "backDevices": "返回遠端裝置",
    "startRemote": "開始遠端任務",
    "recentSessions": "最近工作階段",
    "deviceNotFound": "找不到這台裝置",
    "deviceUnavailable": "裝置無法使用，或目前帳號沒有存取權限。",
    "encryptedSession": "對話內容已加密",
    "pairToRead": "配對此瀏覽器後才能查看對話。"
},
  cloudDeviceGuide: {
    installHint: '在這台裝置上安裝最新版 jcode，以使用遠端工作區功能。',
    download: '下載或更新 jcode',
    "secure": "端對端加密連線",
    "section": "遠端連線",
    "title": "連接 jcode 裝置",
    "description": "登入並授權裝置，再與此瀏覽器配對，即可開啟加密工作區和對話。",
    "steps": "裝置連接步驟",
    "login": "登入 jcode",
    "approve": "授權裝置",
    "pair": "加密配對",
    "newDevice": "新增遠端連線",
    "minute": "約一分鐘",
    "runCommand": "執行登入命令",
    "getCode": "取得一次性裝置碼",
    "confirmIdentity": "確認裝置身分",
    "approveAccount": "允許關聯目前帳號",
    "completePair": "完成配對",
    "approveLocal": "在本機 jcode 中確認",
    "onDevice": "在需要連接的裝置上",
    "runLogin": "執行 jcode login",
    "commandDescription": "命令將產生一次性授權碼，並自動開啟瀏覽器。如果未自動開啟，請在下方輸入裝置碼。",
    "terminal": "終端機",
    "copyCommand": "複製登入命令",
    "copyError": "複製失敗，請選取上方命令手動複製。",
    "enterCode": "輸入 CLI 顯示的裝置碼",
    "continue": "繼續授權",
    "ciphertext": "雲端僅轉發密文",
    "ciphertextDescription": "裝置碼將此次登入關聯到你的帳號。配對金鑰僅保留在 jcode 和此瀏覽器，伺服器無法讀取對話內容。",
    "connected": "已連接的裝置",
    "connectedDescription": "開啟裝置工作區，或繼續上方步驟新增另一台裝置。",
    "expires": "授權碼的剩餘有效時間會顯示在 jcode 中。"
},
  common: {
    ok: '確定',
    add: '新增',
    back: '返回',
    cancel: '取消',
    close: '關閉',
    save: '儲存',
    saving: '儲存中…',
    saved: '已儲存',
    delete: '刪除',
    remove: '移除',
    edit: '編輯',
    rename: '重新命名',
    retry: '重試',
    loading: '載入中…',
    enable: '啟用',
    disable: '停用',
    search: '搜尋',
    done: '完成',
    other: '其他',
    details: '詳情',
    connected: '已連線',
    disconnected: '未連線',
    configured: '已設定',
    notConfigured: '未設定',
    recommended: '建議',
    copy: '複製',
    copied: '已複製',
    dismiss: '忽略',
    create: '建立',
    creating: '建立中…',
    confirm: '確認',
    continue: '繼續',
  },

  language: {
    label: '語言',
  },

  format: {
    justNow: '剛剛',
    minutesAgo: '{n} 分鐘前',
    hoursAgo: '{n} 小時前',
    daysAgo: '{n} 天前',
    durationSeconds: '{n} 秒',
    durationMinutes: '{m} 分',
    durationMinutesSeconds: '{m} 分 {s} 秒',
    durationHoursMinutes: '{h} 小時 {m} 分',
  },

  run: {
    permissionArgumentsUnavailable: '這條舊審批記錄未儲存實際參數。',
    thinking: '思考中',
    thinkingAria: '思考中…',
    projectMember: '儲存庫成員',
    toolStatusDone: '完成',
    tool: {
      read: '讀取專案上下文',
      edit: '編輯檔案',
      execute: '執行命令',
      search: '搜尋工作區',
    },
    toolStatus: {
      running: '執行中',
      failed: '失敗',
      queued: '佇列中',
      canceled: '已取消',
    },
    statusName: {
      queued: '佇列中',
      running: '執行中',
      succeeded: '成功',
      failed: '失敗',
      canceled: '已取消',
      scheduling: '排程中',
      awaiting_input: '等待輸入',
      blocked: '受阻',
    },
    unknownStatus: '未知',
    finalStatus: '最終狀態：{status}',
    status: '狀態：{status}',
    artifactReady: '產物已就緒：{artifact}',
    pushedAt: '已於 {sha} 推送 {branch}',
    pushed: '已推送 {branch}',
    result: {
      noChanges: '無程式碼變更',
      generic: '結果',
    },
    session: {
      resumed: '工作階段已恢復',
      established: '工作階段已建立',
      finished: '工作階段已結束',
      finishedIdle: '工作階段已結束（閒置逾時）',
    },
    permissionTimedOut: '權限請求已逾時',
    permissionResolved: '權限已處理',
    unknownEvent: '未知事件：{type}',
    toolStarted: '{tool} 已開始',
    toolFailed: '{tool} 失敗',
    toolCompleted: '{tool} 已完成',
    permission: {
      label: '權限',
      required: '需要權限',
      noAction: '無動作（已取消）',
      timedOut: '已逾時',
      resolved: '已處理',
      answered: '已回覆 — 正在等待 agent…',
      readonly: '唯讀 — 儲存庫成員可以回覆。',
    },
  },

  workspace: {
    provider: {
      pathOrUrl: '路徑 / 遠端 URL',
      gitRepository: 'Git 儲存庫',
    },
    runKind: {
      review: '審查',
      prEvent: 'PR 事件',
      schedule: '排程',
      kanban: 'Kanban',
      webhook: 'Webhook',
      session: '工作階段',
      task: '工作',
    },
  },

  shell: {
    skipToContent: '跳至主要內容',
    globalNav: '全域導覽',
    primaryNav: '主要',
    workspaceEyebrow: '工作區',
    adminEyebrow: '管理',
    clusterTitle: 'Cluster',
    cloudTitle: 'jcode Cloud',
    clusterSubtitle: 'Cluster 設定',
    cloudSubtitle: '自架的程式開發工作區',
    projects: '專案',
    cluster: 'Cluster',
    devices: '裝置',
    clusterSections: 'Cluster 區段',
    adminBadge: '管理員',
    recentProjects: '最近的 Repositories',
    recentEmpty: '你開啟過的 Repository 會以捷徑形式顯示在此。',
    recentAria: '最近的 Repositories',
    workspaceAria: 'jcode Cloud 工作區',
    demoEnv: '示範 / 本機',
    orchestratorEnv: '協調器',
    demoTag: 'DEMO',
    switchToLight: '切換到淺色模式',
    switchToDark: '切換到深色模式',
    services_one: '{count} 個服務',
    services_other: '{count} 個服務',
    crumbProjects: '專案',
    crumbNewProject: '新增專案',
    crumbCluster: 'Cluster',
    crumbModels: '模型',
    crumbConnections: '連線',
    crumbOverview: '總覽',
    crumbWorkspace: '工作區',
    crumbProject: '專案',
    crumbDevice: '裝置',
    crumbSession: '工作階段',
    crumbNotFound: '找不到頁面',
  },

  cluster: {
    accessDenied: {
      roleCode: '角色 / 專案管理員',
      title: 'Cluster 不在此角色的範圍內。',
      body: '你的角色僅管理儲存庫。容量、模型憑證、防護欄與供應商設定需要 Cluster 管理員。',
      noticeTitle: 'Cluster 導覽已刻意隱藏。',
      noticeBody: '此直接路徑說明邊界，但不會發出系統快照請求。',
      backToProjects: '返回儲存庫',
    },
    overview: {
      loadingSnapshot: '正在載入 Cluster 快照…',
      snapshotLoadError: '無法載入 Cluster 快照',
      eyebrow: '協調器快照',
      title: 'Cluster',
      description: '此協調器的容量、防護欄與執行環境連接設定。可編輯的設定保留在其所屬的區段中。',
      metaNamespace: '命名空間 / {value}',
      metaLauncher: '啟動器 / {value}',
      metaCommit: '提交 / {value}',
      snapshotLoaded: '快照已載入',
      refresh: '重新整理',
      capacitySummaryAria: '執行容量摘要',
      metricRunning: '執行中',
      metricRunningNote: '目前使用中',
      metricScheduling: '排程中',
      metricSchedulingNote: '等待 Pod',
      metricQueued: '佇列中',
      metricQueuedNote: '等待容量',
      metricMax: '上限',
      metricMaxNote: '並行執行',
      capacityTitle: '容量',
      capacityAside: '{active} 使用中 / 上限 {max}',
      concurrencyUncapped: '並行數未設上限',
      concurrencyInUse: '的已設定並行數使用中',
      unlimitedSlots: '無限制名額',
      slotsAvailable: '{count} 個名額可用',
      legendRunning: '{count} 個執行中',
      legendScheduling: '{count} 個排程中',
      gitPolicyTitle: 'Git 供應商政策',
      giteaEnabled: 'Gitea 已啟用',
      giteaDisabled: 'Gitea 已停用',
      giteaUrlLabel: 'Gitea URL',
      draftPrLabel: '草稿 PR 輸出',
      draftPrAvailable: '開放給已授權的身分',
      draftPrUnavailable: '無法使用 — 僅提供 diff',
      allowedHostsLabel: '允許的 Git 主機',
      unrestricted: '不限制',
      modelsConfigured_one: '已設定 {count} 個目錄模型。',
      modelsConfigured_other: '已設定 {count} 個目錄模型。',
      modelsManagedPrefix: '模型憑證與帳號授權於 ',
      modelsLink: '模型',
      modelsManagedSuffix: ' 中管理；帳號與儲存庫永遠不會收到供應商金鑰。',
      guardrailsTitle: '防護欄',
      runTimeoutLabel: '執行逾時',
      jobTtlLabel: 'Job TTL',
      runnerTitle: '執行器',
      imageLabel: '映像檔',
      launcherLabel: '啟動器',
      workspaceLabel: '工作區',
      persistent: '持久',
      ephemeral: '臨時',
      prewarmLabel: '映像檔預下載',
      prewarmUnsupported: '需要 Kubernetes 啟動器',
      prewarmNever: '尚未同步',
      prewarmReady: '{ready}/{desired} 節點已快取',
      prewarmLastSyncLabel: '上次同步',
      prewarmSync: '同步最新映像檔',
      prewarmSyncError: '同步失敗,請查看 orchestrator 日誌',
      buildTitle: '建置',
      versionLabel: '版本',
      commitLabel: '提交',
      usersLabel: '使用者',
      coldArchiveUnavailable: '冷儲存無法使用。',
    },
    models: {
      contextUnknown: '上下文未知',
      contextK: '{value}K 上下文',
      context: '{value} 上下文',
      eyebrow: 'Cluster 目錄',
      title: '模型供應商',
      description: '連接供應商一次並密封保存憑證，再將模型存取權直接授予帳號。',
      addProvider: '新增供應商',
      securityNote: '供應商金鑰為唯寫。目錄僅回報是否已設定憑證，絕不會顯示所儲存值的任何部分。',
      filterLabel: '篩選模型或供應商',
      filterPlaceholder: '篩選模型或供應商…',
      resultCount: '/ 共 {total} 個模型',
      configuredProviders: '已設定的供應商',
      providersSummary: '{providers} 個供應商 · {accountGrants} 項帳號授權',
      loadingProviders: '正在載入模型供應商…',
      loadProvidersError: '無法載入模型供應商',
      noMatches: '沒有符合的模型或供應商。',
      noProviders: '尚未設定任何模型供應商。',
      noMatchesHint: '試試供應商名稱、模型 id 或功能。',
      noProvidersHint: '新增供應商，讓帳號可在 Desktop 與儲存庫任務中使用模型。',
      authServiceIdentity: '服務身分',
      authKeySet: '已設金鑰',
      authKeyless: '免金鑰',
      authKeyMissing: '缺少金鑰',
      verifiedIn: '供應商已於 {ms} 毫秒內驗證。',
      reachableIn: '供應商於 {ms} 毫秒內可連線；目錄無法使用。',
      verifyError: '無法驗證此供應商。',
      removeConfirm: '要移除 {name} 及其所有已設定的模型嗎？',
      providerRemoved: '已移除供應商。',
      removeError: '無法移除此供應商。',
      customLabel: '自訂',
      credKeylessIdentity: '免金鑰工作負載身分',
      credConfigured: '已設定憑證',
      credNoneRequired: '不需要憑證',
      credRequired: '需要憑證',
      lastTest: '上次測試：{error}',
      verified: '已驗證',
      test: '測試',
      editProviderAria: '編輯 {name} 供應商',
      removeProviderAria: '移除 {name} 供應商',
      customModel: '自訂模型',
      configuredModel: '已設定的模型',
      configuredModels: '已設定的模型',
      catalogUnavailable: '目錄無法使用',
      browseCatalog: '瀏覽目錄',
      customModelAction: '自訂模型',
      limitNote: '此端點不會公開模型目錄。模型必須明確新增；不會替換為任何後援目錄。',
      capabilitiesAria: '模型能力',
      capReasoning: '推理',
      capTools: '工具',
      capImage: '圖片',
      projectGrants_one: '專案授權',
      projectGrants_other: '專案授權',
      accountGrants_one: '帳號授權',
      accountGrants_other: '帳號授權',
      manageAccess: '管理存取',
      capabilitiesLegend: '能力',
      capToolUse: '工具呼叫',
      capImageInput: '圖片輸入',
      customValidationRequired: '顯示名稱與模型 ID 為必填。',
      customValidationContext: '上下文視窗必須為零或正數。',
      customAdded: '已新增自訂模型。',
      addModelError: '無法新增此模型。',
      customDialogTitle: '自訂模型 · {name}',
      addCustomModel: '新增自訂模型',
      displayNameLabel: '顯示名稱',
      displayNamePlaceholder: '例如：Coding Plan',
      modelIdLabel: '模型 ID',
      modelIdHint: '純上游模型 id；執行階段的供應商前綴會在伺服器端加上。',
      contextWindowLabel: '上下文視窗',
      modelAdded: '已新增 {name}。',
      addCatalogError: '無法新增此目錄模型。',
      syncMetadata: '同步中繼資料',
      metadataSynced: '已同步 {name} 的中繼資料。',
      syncMetadataError: '無法同步模型中繼資料。',
      catalogDialogTitle: '目錄 · {name}',
      loadingCatalog: '正在載入供應商目錄…',
      catalogLoadError: '無法載入目錄',
      catalogLoadFallback: '無法載入供應商目錄。',
      grantUpdateError: '無法更新專案授權。',
      accountGrantUpdateError: '無法更新帳號存取權限。',
      accessDialogTitle: '模型存取 · {name}',
      accessIntro: '一次按帳號授權，同時用於 Cloud 和 Desktop。供應商憑證始終密封在 Cluster 邊界內。',
      accessTabsAria: '模型存取範圍',
      accessAccounts: '帳號',
      accessProjects: '專案',
      accountAccessIntro: '授權後，該帳號的 Repository 任務及所有 Desktop 都可使用此模型。',
      projectAccessIntro: '獲授權的專案可在 Cloud 任務中選擇此模型。',
      accountSearchLabel: '搜尋帳號',
      accountSearchPlaceholder: '搜尋帳號…',
      loadingAccounts: '載入帳號…',
      noAccounts: '沒有相符的帳號。',
      allDesktops: '目前及日後新增的全部 Desktop',
      allCloudAndDesktop: '全部 Repository 任務和 Desktop',
      clusterAdminAccount: 'Cluster 管理員 · 全部 Desktop',
      loadingProjects: '正在載入專案…',
      noProjects: '尚無任何專案。',
      servicesCount: '{count} 個服務',
      providerValidationRequired: '名稱、供應商類型與 Base URL 為必填。',
      providerValidationKey: '新的 API 金鑰供應商必須填寫 API 金鑰。',
      providerSaved: '已儲存供應商。',
      saveProviderError: '無法儲存此供應商。',
      providerAdded: '已新增供應商。',
      addProviderError: '無法新增此供應商。',
      editProviderTitle: '編輯供應商 · {name}',
      addProviderTitle: '新增模型供應商',
      saveProvider: '儲存供應商',
      providerSourceLabel: '供應商來源',
      providerRegistryMode: '供應商',
      providerCustomMode: '自訂',
      providerSelectLabel: '供應商',
      providerSelectPlaceholder: '選擇供應商',
      providerNameLabel: '供應商名稱',
      providerNamePlaceholder: '例如：Zhipu AI',
      providerTypeLabel: '供應商類型',
      providerTypeHint: '小寫的執行階段前綴，例如 openai、qwen 或 zhipu。',
      baseUrlLabel: 'Base URL',
      authLabel: '驗證',
      authApiKey: 'API 金鑰',
      authServiceIdentityOption: '服務身分',
      authNone: '無憑證',
      rotateApiKeyLabel: '輪換 API 金鑰',
      apiKeyPlaceholderKeep: '留空以保留目前的金鑰',
      apiKeyPlaceholderEnter: '輸入供應商金鑰',
      apiKeyHint: '唯寫。已儲存的值永遠無法再讀回。',
      catalogLabel: '模型目錄',
      catalogAuto: '從 /models 探索',
      catalogDisabled: '無法使用 — 僅限自訂模型',
      advancedLabel: '進階',
      headersHint: '隨每次請求送往此供應商的自訂 Header。值為唯寫。',
      headersConfiguredHint: '已設定自訂 Header。新增列以取代，或留空以保留。',
      headerKeyPlaceholder: 'Header 名稱',
      headerValuePlaceholder: '值',
      addHeader: '新增 Header',
      removeHeader: '移除 Header',
      headerValidation: '每個 Header 都需要同時填寫名稱與值。',
    },
    connections: {
      loading: '正在載入 Cluster 連線…',
      statusError: '無法載入連線狀態',
      configError: '無法載入 jtype 設定',
      eyebrow: '外部系統',
      title: '連線',
      description: 'Cluster 範圍的端點與身分供應商。儲存庫授權保留在各儲存庫連線中。',
      configurationTabs: '連線設定',
      integrationsTab: '整合設定',
      loginTab: '登入設定',
      statusEyebrow: '生效狀態',
      statusTitle: '連線狀態',
      statusDescription: 'Cluster 回報的唯讀執行狀態，與可編輯的供應商設定分開顯示。',
      configuredCount: '已設定 {count} 個',
      gitPolicyTitle: 'Git 供應商政策',
      gitPolicySubtitle: '由環境擁有 · 唯讀',
      giteaEnabled: 'Gitea 已啟用',
      giteaDisabled: 'Gitea 已停用',
      giteaUrlLabel: 'Gitea URL',
      clusterPatLabel: 'Cluster PAT',
      patConfigured: '已設定 · 值已隱藏',
      allowedHostsLabel: '允許的主機',
      unrestricted: '不限制',
      oobTitle: '變更需透過帶外方式進行。',
      oobBody: '供應商 URL、PAT 與主機允許清單仍屬於部署設定；此頁面僅回報實際狀態。',
      authTitle: '驗證',
      registeredUsers: '{count} 位已註冊使用者',
      oauthOn: 'OAuth 已開啟',
      tokenOnly: '僅權杖',
      giteaOauthLabel: 'Gitea OAuth',
      githubOauthLabel: 'GitHub OAuth',
      consoleTokenLabel: '主控台權杖',
      consoleTokenValue: 'Cluster 管理員備援',
      oauthSecurityNote: 'OAuth 重新導向 URI 需透過供應商 UI 變更，因為以 API 修補會輪換用戶端密鑰。',
      githubUnavailableTitle: 'GitHub 登入無法使用。',
      githubUnavailableBody: '尚未設定任何 GitHub OAuth 供應商。在供應商存在之前，UI 不會顯示可用的 GitHub 按鈕。',
      providerHealth: {
        unknown: '尚未檢測',
        healthy: '正常',
        partial: '基本連線正常',
        error: '錯誤',
        incomplete: '設定不完整',
      },
      providerHealthError: '連線檢查失敗：{message}',
      githubAppSetupIncomplete: 'GitHub App 設定不完整',
      instanceUrl: '執行個體 URL',
      providerCapabilities: '供應商能力',
      loginEnabled: '已啟用登入',
      loginCapability: '登入',
      loginCapabilityHint: '允許使用此供應商登入 Cloud。',
      pluginEnabled: '已啟用外掛',
      pluginCapability: '外掛',
      pluginCapabilityHint: '允許儲存庫連接並使用此外掛。',
      oauthClientId: 'OAuth 用戶端 ID',
      oauthClientSecret: 'OAuth 用戶端密鑰',
      configuredReplace: '已設定 — 輸入新值以取代',
      enterSecret: '輸入密鑰',
      githubAppId: 'GitHub App ID',
      githubAppPrivateKey: 'GitHub App 私鑰',
      configuredPemReplace: '已設定 — 貼上 PEM 以取代',
      pastePrivateKeyPem: '貼上完整的私鑰 PEM',
      privateKeyHint: '僅可寫入。Cloud 會加密 PEM，且絕不會將其傳回瀏覽器。',
      webhookSecret: 'Webhook 密鑰',
      webhookSecretPlaceholder: '輸入與 GitHub 中設定相同的密鑰',
      githubAppConfigurationIncomplete: 'GitHub App 設定不完整',
      githubAppConfigurationIncompleteHint: '請新增 App ID、私鑰及相符的 Webhook 密鑰，之後帳號才能列出 Installation。',
      testConnection: '測試連線',
      jtypeSaved: '已儲存 jtype 連線。',
      jtypeSaveError: '無法儲存 jtype。',
      jtypeOverrideRemoved: '已移除 jtype DB 覆寫。',
      jtypeRemoveError: '無法移除覆寫。',
      sourceDb: 'DB 覆寫',
      sourceEnv: '環境備援',
      sourceNone: '未設定',
      jtypeKanban: 'jtype Kanban',
      pollingEvery: '每 {interval} 輪詢一次',
      jtypeEffective: '生效',
      jtypeBroken: '異常',
      jtypeOff: '關閉',
      baseUrlLabel: 'Base URL',
      baseUrlHint: '本叢集連接的 jtype 實例。看板憑證完全由各專案擁有者按連結管理。',
      boardTrafficNote: '看板流量會經過伺服器代理。jtype 權杖永遠不會進入瀏覽器。',
      jtypeUnavailableTitle: 'jtype 設定無法使用。',
      removeOverride: '移除覆寫',
      saveJtype: '儲存 jtype',
      archiveTitle: '工作區封存',
      archiveSubtitle: '持久工作區冷儲存',
      archiveEnabled: '已啟用',
      archiveUnavailable: '無法使用',
      endpointLabel: '端點',
      bucketLabel: '儲存桶',
      idleWindowLabel: '閒置期間',
      idleDays: '{count} 天',
      archiveDisabledTitle: '長期封存尚未啟用。',
      archiveDisabledReason: '尚未設定物件儲存。',
    },
    system: {
      forbiddenTitle: 'Cluster 檢視僅供 Cluster 管理員使用',
      forbiddenDescription: '你的角色僅管理專案。如需容量、防護欄與供應商詳情，請洽 Cluster 管理員。',
      title: 'Cluster',
      subtitle: '此協調器的快照：容量、防護欄與連接設定。模型在此設定；其他變更以帶外方式進行（env / kubectl）。',
      loadingSnapshot: '正在載入 Cluster 快照…',
      snapshotError: '無法載入 Cluster 快照',
      noSnapshotTitle: '無快照',
      noSnapshotDescription: '協調器未回傳任何系統資訊。',
      capacityTitle: '容量',
      unlimitedConcurrency: '無限制並行數',
      activeMax: '{active} 使用中 / 上限 {max}',
      capacityBarAria: '使用中的執行相對於最大並行數',
      statRunning: '執行中',
      statScheduling: '排程中',
      statQueued: '佇列中',
      statMaxConcurrent: '最大並行數',
      guardrailsTitle: '防護欄',
      runTimeoutLabel: '執行逾時',
      jobTtlLabel: 'Job TTL',
      providerTitle: '供應商',
      giteaEnabled: 'Gitea 已啟用',
      giteaDisabled: 'Gitea 已停用',
      draftPrsLabel: '草稿 PR',
      on: '開啟',
      offDiffOnly: '關閉（僅 diff）',
      giteaUrlLabel: 'Gitea URL',
      allowedHostsLabel: '允許的 git 主機',
      unrestrictedAnyHost: '不限制（任何主機）',
      allowedHostsHint: '專案整合只能以這些主機為目標（ALLOWED_GIT_HOSTS）。空白 = 任何主機。',
      runnerTitle: '執行器',
      imageLabel: '映像檔',
      namespaceLabel: '命名空間',
      launcherLabel: '啟動器',
      persistentWorkspaceLabel: '持久工作區',
      off: '關閉',
      authTitle: '驗證',
      providerCount_one: '{count} 個供應商',
      providerCount_other: '{count} 個供應商',
      tokenOnly: '僅權杖',
      oauthProvidersLabel: 'OAuth 供應商',
      noneConsoleToken: '無（僅主控台權杖）',
      usersLabel: '使用者',
      versionTitle: '版本',
      orchestratorLabel: '協調器',
      commitLabel: '提交',
      modelCatalogTitle: '模型目錄',
      modelCount_one: '{count} 個模型',
      modelCount_other: '{count} 個模型',
      noModels: '無模型',
      modelCatalogHint: '註冊 OpenAI 相容端點，然後依專案授權它們。專案在至少擁有一個已授權模型之前，執行都會被封鎖。',
      loadingModelCatalog: '正在載入模型目錄…',
      modelCatalogError: '無法載入模型目錄',
      noModelsYet: '尚無模型 — 請在下方新增。',
      keySet: '已設金鑰',
      keyless: '免金鑰',
      modelSaved: '已儲存模型。',
      modelSaveError: '無法儲存此模型。',
      modelRemoved: '已移除模型。',
      modelRemoveError: '無法移除此模型。',
      nameLabel: '名稱',
      baseUrlLabel: 'Base URL',
      modelProviderLabel: '模型（供應商/模型）',
      apiKeyLabel: 'API 金鑰',
      apiKeyPlaceholderClear: '將被清除（免金鑰）',
      apiKeyPlaceholderRotate: '•••••••• （空白 = 不變更；輸入以輪換）',
      apiKeyPlaceholderNew: 'sk-…  （空白表示免金鑰）',
      apiKeyHint: '以加密方式儲存。儲存後永不顯示。',
      clearKeyLabel: '清除金鑰（讓此端點免金鑰）',
      noProjectsToAuthorize: '尚無可授權的專案。',
      authorizedProjects: '已授權的專案',
      grantUpdateError: '無法更新授權。',
      modelAdded: '已新增模型。',
      modelAddError: '無法新增此模型。',
      apiKeyPlaceholderAdd: 'sk-…  （空白表示免金鑰端點）',
      addModel: '新增模型',
    },
  },

  app: {
    linked: '已連結你的 {provider} 帳號。',
    linkTaken: '該帳號已連結到另一位使用者。',
    linkError: '無法連結該帳號。',
    auth: {
      loginProviderDenied: '供應商拒絕了登入請求。請重試。',
      loginExchangeFailed: '登入無法完成（權杖交換失敗）。',
      loginProfileFailed: '登入無法從供應商讀取你的個人資料。',
      loginServerMisconfigured: '伺服器尚未設定登入功能。',
      loginServerError: '伺服器在完成登入時發生錯誤。',
      loginFailed: '登入失敗，請重試。',
      enterToken: '請輸入主控台權杖。',
      superseded: '已被取代。',
      tokenRejected: '權杖遭協調器拒絕。',
      lostOrchestrator: '與協調器失去連線 — 請參閱設定步驟。',
    },
  },

  components: {
    modelGate: {
      unverified: '無法驗證模型狀態 — 若無可用模型，執行可能失敗。',
      notConfigured: '此專案沒有可用的模型，因此無法開始執行。',
      grantLink: '在 Cluster 頁面授權模型',
      contactAdmin: '請聯絡 Cluster 管理員，為此專案授權模型。',
    },
    prPanel: {
      stateOpen: '開啟中',
      stateMerged: '已合併',
      stateClosed: '已關閉',
      stateUnknown: '未知',
      stateAria: 'Pull request 狀態：{state}',
      reviewRequested: '已請求 AI 審查。',
      reviewError: '無法請求審查。',
      loading: '正在載入 pull request…',
      loadError: '無法載入 pull request',
      noPr: '尚未開啟任何 pull request。',
      requestReview: '請求 AI 審查',
      reviewsTitle: '審查',
      reviewsEmpty: '尚無 AI 審查。',
      hide: '隱藏',
      show: '顯示',
      reviewFailed: '審查執行在產生輸出前失敗。',
      reviewInProgress: '審查進行中…',
    },
    states: {
      cannotReach: '無法連線到協調器。它正在執行嗎？',
      somethingWrong: '發生錯誤。',
      failedToLoad: '載入失敗',
    },
    statusBadge: {
      queued: '佇列中',
      scheduling: '排程中',
      running: '執行中',
      awaitingInput: '等待輸入',
      succeeded: '成功',
      failed: '失敗',
      canceled: '已取消',
      blocked: '受阻',
      aria: '狀態：{status}',
    },
    gitMode: {
      legend: 'Git 整合',
      modeAria: 'Git 整合模式',
      readonlyLabel: '唯讀 diff',
      readonlyHint: '成功的執行僅產生 diff 產物 — 不會推送任何內容。',
      draftPrLabel: '草稿 PR',
      draftPrHint: '成功時，agent 會推送分支並開啟草稿 PR 供審查。絕不會自動合併，也不會觸發 CI。',
      draftPrTitle: '成功的執行會推送分支並開啟草稿 PR 供審查。',
      readonlyTitle: '成功的執行僅產生 diff 產物 — 不會推送任何內容。',
    },
    identity: {
      roleClusterAdmin: 'Cluster 管理員',
      roleProjectAdmin: '儲存庫管理員',
      signOut: '登出',
      serviceNote: '已使用主控台權杖驗證 — 無已連結的身分。',
      session: '工作階段',
      linkedAccounts: '已連結的帳號',
      noLinkedAccounts: '尚無已連結的帳號。',
      linkAnother: '連結其他帳號',
      link: '連結 {name}',
    },
    kanbanConnect: {
      startError: '無法開始連接流程。',
      connect: '以 jtype 連接',
      enterCode: '在 jtype 中輸入此代碼以授權：',
      openJtype: '開啟 jtype 以授權',
      waiting: '正在等待你在 jtype 中授權…',
      connected: '已連接 — 權杖已設定',
      failed: '連接失敗 — 請再次點擊 Connect。',
      expired: '連接已逾期 — 請再次點擊 Connect。',
      unsupported: '此 jtype 部署不支援一鍵 Connect — 請改為貼上權杖。',
      expiryExpired: '已逾期',
      expiresInDays_one: '{count} 天後逾期',
      expiresInDays_other: '{count} 天後逾期',
    },
    projectSwitcher: {
      allProjects: '所有專案',
      noProjects: '尚無專案',
    },
    modal: {
      close: '關閉對話框',
    },
  },


  members: {
    addedAs: '已將 {name} 新增為 {role}。',
    addError: '無法新增成員。',
    updateRoleError: '無法更新角色。',
    removed: '已移除 {name}。',
    removeError: '無法移除成員。',
    searchPlaceholder: '依名稱搜尋人員…',
    searchAria: '搜尋要新增的人員',
    searching: '搜尋中…',
    noMatches: '沒有符合的人員。',
    adminTag: '管理員',
    roleForAddedAria: '所新增成員的角色',
    roleForAria: '{name} 的角色',
    removeAria: '移除 {name}',
    loading: '正在載入成員…',
    loadError: '無法載入成員',
    roleOwner: '擁有者',
    roleMember: '成員',
    roleViewer: '檢視者',
  },


  kanban: {
    enableTitle: '連接 Agent Board',
    enableBody: '選擇既有 Board、執行模型，以及用於觸發、進行中與可選完成的欄。',
    pluginRequired: '請先連接 JType 並選擇工作區，再綁定 Agent Board。',
    loadingAccountModels: '正在載入帳號模型…',
    accountModelsUnavailable: '無法載入帳號模型。',
    accountModelRequired: '啟用 Agent Board 前，請先為此帳號授權至少一個模型。',
    loadingBoards: '正在載入看板…',
    boardsUnavailable: '無法載入看板，請檢查 JType 外掛連線。',
    enable: '連接 Agent Board',
    disable: '中斷連接',
    triggerColumn: '觸發欄',
	workColumn: '進行中欄',
    doneColumn: '完成欄',
    noDoneColumn: '完成後不移動卡片',
    columnSettings: '自動化欄',
    columnSettingsHint: '就地編輯卡片如何啟動任務，以及完成後移動到哪裡。',
    columnsUnavailable: '無法載入欄選項，請檢查 JType 外掛連線。',
    notConfiguredTitle: 'Kanban 尚未設定',
    notConfiguredMsg: 'Cluster 管理員需先設定 jtype 整合，才能開啟此看板。',
    tlsInvalidTitle: 'JType 憑證需要修復',
    tlsInvalidMsg: '無法驗證 JType 的 HTTPS 憑證。請聯絡管理員續期或修復憑證，然後重試。',
    unavailableTitle: 'Kanban 無法使用',
    unavailableMsg: '無法連線到 jtype 服務。請在服務可用時重試。',
    unauthorizedTitle: 'Kanban 存取需要處理',
    unauthorizedMsg: '目前的 JType 連接無法讀取此 Board。Repository owner 或 Cluster 管理員需修復連接。',
    workspaceNotFoundTitle: '找不到 Kanban 工作區',
    workspaceNotFoundMsg: '此 Agent Board 指向的 JType 工作區已無法使用。',
    boardNotFoundTitle: '無法開啟此看板',
    boardNotFoundMsg: '此看板可能已被刪除或重新命名，或整合已失去存取權。',
    boardOpenDefaultMsg: '目前無法開啟 Board。請重試，或請 Repository owner 檢查連接。',
    title: 'Agent Board',
    boardLabel: '看板',
    openingBoard: '正在開啟看板…',
    loadingPolicy: '正在載入執行策略…',
    policyUnavailable: '無法載入執行策略。',
    policyTrigger: 'Card 進入 {column} 時啟動 jcode',
	policyWork: '接收後將 Card 移入 {column}',
	policyWorkMissing: '接收後不會將 Card 移入 WIP',
    policyWriteback: '成功後留言並移動到 {column}',
    policyCommentOnly: '結果寫入 Card 留言',
    policyReady: '可執行',
    policyBlocked: '已阻塞 · {blocker}',
    policyBlockers: {
      binding_disabled: '自動化已停用',
      plugin_unavailable: 'JType 連線無法使用',
      event_feed_unavailable: 'JType 事件流無法使用',
      bootstrap_unavailable: 'JType 卡片初始化無法使用',
      card_index_unavailable: 'JType 卡片索引無法使用',
      card_read_unavailable: 'JType 卡片暫時無法讀取',
      card_unavailable: 'JType 卡片無法使用',
      board_validation_unavailable: 'JType 看板驗證無法使用',
      board_drift: '看板或自動化欄位已變更',
      repository_not_configured: '尚未設定程式碼儲存庫',
      repository_unavailable: '程式碼儲存庫連線無法使用',
      provider_unavailable: '程式碼儲存庫 Provider 無法使用',
      runner_unavailable: 'Runner 無法使用',
      run_unavailable: '關聯的 Cloud Run 無法使用',
      model_not_configured: '尚未設定模型',
      model_not_authorized: '執行帳號未獲得此模型授權',
      model_authorization_unavailable: '暫時無法驗證模型授權',
      execution_account_not_owner: '執行帳號已不是 Repository owner',
      work_column_not_configured: '尚未設定進行中欄',
      model_effort_unsupported: '模型不支援所選推理強度',
    },
    executionsTitle: 'Cloud 執行',
    loadingExecutions: '正在載入 Cloud 執行…',
    executionsUnavailable: '無法載入 Cloud 執行記錄。',
    noExecutions: '尚無 Cloud 執行。將此 Card 移入「啟動 jcode」欄即可要求執行。',
    runWithAgent: '使用 Agent 執行',
    agentRunActive: 'Agent 正在執行',
    rerunDoneConfirm: '此 Card 已在 Done 欄。仍要再次執行並將它移回進行中欄嗎？',
    executionState: {
      received: '已收到要求',
      blocked: '受阻',
      queued: '排隊中',
      running: '執行中',
      terminal: '已結束',
      succeeded: '成功',
      failed: '失敗',
      canceled: '已取消',
    },
    requestedByExternal: '要求者：{actor}',
    projectOwner: '專案擁有者',
    repositoryOwner: '儲存庫擁有者',
    clusterAdmin: 'Cluster 管理員',
    openRun: '開啟 Run',
    writebackPending: 'Card 回寫待完成',
    writebackUnavailable: '來源 Card 無法使用',
    executionSummary: {
      received: '已收到 Card 要求。',
      queued: 'Run 正在排隊。',
      running: 'Run 正在執行所要求的變更。',
      succeeded: 'Run 已成功完成。',
      failed: 'Run 執行失敗。',
      canceled: 'Run 已取消。',
    },
    priorExecutions_one: '{count} 次歷史執行',
    priorExecutions_other: '{count} 次歷史執行',
    cardUnavailable: '此 Card 已不在 JType 中，Cloud 執行歷史仍會保留。',
    loadEarlierExecutions: '載入更早的執行',
    linkDisabledTitle: '此 Kanban 自動化連結已停用。',
    linkDisabledBody: '看板可供檢視，但卡片觸發的執行與回寫已停用。',
  },

  onboarding: {
    setupStep1: '建置四個本機映像檔',
    setupStep2: '部署到 OrbStack cluster 並等待推出完成',
    setupStep3: '將協調器 API 轉發到 localhost:8080',
    probingEyebrow: '連線中',
    probingTitle: '讓執行環境進入可連線狀態。',
    probingStory: '主控台正在檢查是否可以開始已驗證的工作流程。',
    probingUtility: '連線設定',
    probingStatus: '探測中',
    setupEyebrow: '本機設定',
    setupTitle: '讓執行環境進入可連線狀態。',
    setupStory: '主控台已就緒。協調器尚未回應，因此無法開始任何已驗證的工作流程。',
    setupUtility: '連線設定',
    setupStatus: '無法連線',
    signinEyebrow: '你的程式碼。你的 Cluster。',
    signinTitle: '讓工作貼近系統。',
    signinStory: 'jcode Cloud 將程式開發工作派發到你的團隊已掌控的基礎設施中。',
    signinUtility: '安全入口',
    signinStatus: '登入',
    welcomeEyebrow: '工作區已就緒',
    welcomeTitle: '第一道邊界由你來設定。',
    welcomeStory: '你是第一個登入的人。jcode Cloud 已將 Cluster 管理員角色指派給此身分。',
    welcomeUtility: '首位使用者設定',
    welcomeStatus: '已登入',
    landingEyebrow: '工作階段已就緒',
    landingTitle: '控制平面已可連線。',
    landingStory: '主控台權杖已為此瀏覽器建立 Cluster 管理員工作階段。',
    landingUtility: '工作階段邊界',
    landingStatus: '已驗證',
    selfHosted: '自架',
    assignedRole: '已指派角色',
    clusterAdministrator: 'Cluster 管理員',
    adminSeparate: 'Cluster 管理權限與儲存庫擁有權是分開的。',
    roleManageGrants: '管理模型授權',
    roleConfigureConnections: '設定連線',
    roleViewCapacity: '檢視容量與政策',
    sessionBoundary: '工作階段邊界',
    whatSignInEstablishes: '登入建立了什麼',
    signInEstablishesBody: '協調器會將供應商身分對應到一個 jcode Cloud 帳號。儲存庫擁有權與供應商存取權會分別評估。',
    providerTokensServerSide: '供應商權杖僅保留在伺服器端，永遠不會呈現到此頁面。',
    currentProbe: '目前探測',
    whatConsoleKnows: '主控台知道什麼',
    probeBody: '此狀態僅回報可連線性。它不會推斷 Kubernetes、映像檔或憑證是否正常。',
    probeTarget: '目標',
    probeResponse: '回應',
    probeUnreachable: '無法連線',
    probeWaiting: '等待中',
    cantReachTitle: '無法連線到協調器',
    setupLede1: '主控台會代理',
    setupLede2: '到',
    setupLede3: '，但沒有任何回應。請將整個堆疊啟動，之後此頁面會自行繼續。',
    recheckingNote: '每 3 秒重新檢查一次 — 無需重新整理',
    checkNow: '立即檢查',
    reasonRejected: '已儲存的權杖遭拒 — 可能已被輪換。請輸入目前的權杖。',
    reasonExpired: '你的工作階段已結束（逾期或已撤銷）。請重新登入。',
    reasonSignedOut: '已登出。',
    continueWith: '使用 {name} 繼續',
    signInHeading: '登入',
    signInLedeNoProviders: '尚未設定任何 OAuth 供應商。請使用部署協調器時所用的主控台權杖。',
    signInLedeProviders: '使用你的 git 供應商繼續，以取得個人的專屬工作階段。',
    advancedConsoleToken: '進階：主控台權杖',
    consoleTokenLabel: '主控台權杖',
    consoleTokenHint: '部署協調器時所用的 CONSOLE_TOKEN — 具 Cluster 管理員權限。儲存在此瀏覽器本機。',
    signInWithToken: '使用權杖登入',
    welcomeFirstAdminTitle: '你是第一位使用者 — Cluster 管理員',
    welcomeGreeting: '歡迎，{name}',
    welcomeFirstAdminLede: '你是第一個登入的人，因此你現在是 Cluster 管理員：你可以看到每個專案並管理容量。在你之後加入的每個人都會以一般使用者身分開始。',
    welcomeLede: '你已登入。建立專案以將 jcode Cloud 指向某個儲存庫，或開啟你已被加入的專案。',
    friend: '朋友',
    signedInAs: '已以 {name} 登入',
    getStarted: '開始使用',
    landingCardTitle: '你已進入 — Cluster 管理員',
    landingLede: '已登入此協調器：',
    principal: '主體',
    access: '存取權',
    accessClusterAdmin: 'Cluster 管理員',
    accessMember: '成員',
    session: '工作階段',
    sessionConsoleToken: '主控台權杖',
    sessionUser: '使用者工作階段',
    identity: '身分',
    everythingHeadless: '一切都在你的 Cluster 中以無介面方式執行。',
    enterConsole: '進入主控台',
    connecting: '正在連線到協調器…',
    mobileHandoff: '正在為手機完成登入…',
    mobileConsentTitle: '在手機上登入',
    mobileConsentLede: '你已以 {name} 身份登入。點擊下方按鈕完成手機 App 登入。',
    mobileConsentContinue: '繼續到 App',
  },

  notFound: {
    title: '此路徑到此為止。',
    body: '此頁面可能已移動，或此連結描述的儲存庫或工作你已無法存取。',
    backToProjects: '返回儲存庫',
  },

  device: {
    compose: {
      project: '工作目錄',
      model: '模型',
      effort: '強度',
      goal: '目標',
      goalPlaceholder: '這個工作階段要達成什麼？',
      attachments: '附件',
      attachAdd: '附加檔案',
      removeAttachment: '移除 {name}',
      deviceDefault: '裝置預設',
      attachmentTooBig: '{name} 超過 2 MB——請選擇較小的檔案。',
      attachmentTooMany: '每則訊息最多 {max} 個附件。',
      attachmentImage: '{name} 是圖片——暫不支援圖片附件。',
    },
    composer: {
      placeholder: '輸入訊息，或鍵入 / 使用指令',
      goalPlaceholder: '描述目標——agent 會持續追求直到可驗證地完成',
      queuePlaceholder: 'Agent 正在工作——輸入以排隊後續訊息…',
      attachedImages: '（見附圖）',
      send: '傳送',
      queue: '排隊',
      stop: '停止',
      stopAgent: '停止 agent (Esc)',
      stopAndNext: '停止目前回合並傳送下一則排隊訊息',
      removeQueued: '從佇列移除',
      add: '新增',
      attachFiles: '附加檔案',
      command: '指令',
      goal: '目標',
      workflowBadge: '工作流程',
      goalSlashDesc: '啟用目標模式——下一則訊息將成為目標',
      goalHintNext: '下一則訊息將成為工作階段目標',
      goalHintNextReplaces: '下一則訊息將取代目前目標',
      goalHintRemove: '移除目標',
      goalHintReplace: '設定新目標會取代目前目標',
      modelNoImages: '目前模型不支援圖片',
      modeApproval: '逐次確認',
      modeApprovalSub: '每次寫入或執行指令前暫停確認。',
      modePlan: '計畫',
      modePlanSub: '先提出計畫；批准前不執行任何操作。',
      modeAuto: '自動',
      modeAutoSub: 'AI 審查放行安全工具；不確定的仍會詢問。',
      modeFullAccess: '完全放行',
      modeFullAccessSub: '自由執行——不再有審批提示。',
      modeCeilingHint: '雲端工作階段最高可使用 Auto 模式。',
      modelFilter: '篩選模型…',
      modelCurrent: '目前',
      modelFavorites: '★ 收藏',
      modelReasoning: '推理',
      modelTools: '工具呼叫',
      modelImages: '圖片輸入',
      modelNoImageInput: '目前模型不支援圖片輸入',
      modelNone: '暫無可用模型',
      modelNoMatch: '沒有符合的模型。',
      modelManage: '管理模型…',
      modelManageTitle: '管理模型',
      modelToggleVisibility: '切換模型在選擇器中的顯示',
      modelVisibleCount: '選擇器中顯示 {visible}/{total} 個模型',
      effort: '推理強度',
      effortTitle: '此模型的推理強度',
      effortDefault: '預設',
      contextTitle: '上下文容量',
      contextSystemPrompt: '系統提示詞',
      contextSystemTools: '系統工具',
      contextMcpTools: 'MCP 工具',
      contextSkills: '技能',
      contextMessages: '訊息',
      contextInput: '輸入',
      contextOutput: '輸出',
      contextCached: '快取',
      contextReasoning: '推理',
      contextCacheHitRate: '快取命中率',
      workspaceNone: '選擇資料夾',
      workspaceUnavailable: '無法讀取目前資料夾。請重試、選擇資料夾，或升級裝置端 jcode 後使用 Chat。',
      workspaceNewConversation: '請返回裝置頁面，在新對話中選擇工作區。',
      workspaceNonePlural: '暫無工作區',
      workspaceSearch: '搜尋工作區',
      workspaceLoading: '載入中…',
      workspaceNoFolders: '沒有資料夾',
      workspaceOpen: '開啟',
      workspaceOpenFolder: '開啟資料夾',
      workspaceOpenError: '開啟工作區失敗',
      workspacePathPlaceholder: '裝置上的路徑',
      remoteConnect: '遠端連線',
      branchesTitle: '分支',
      branchesNone: '沒有分支',
      branchSearch: '搜尋分支',
      branchCreate: '建立並切換到新分支',
      branchCreateBtn: '建立',
      branchNewName: 'new-branch-name',
      branchCurrent: '分支：{name}',
      branchConfirmTitle: '有未提交的變更',
      branchConfirmIntro: '切換到 "{branch}" 將覆蓋以下本機檔案：',
      branchConfirmMore: '另有 {count} 個',
      branchConfirmStash: '儲藏並切換',
      branchConfirmDiscard: '捨棄並切換',
      branchConfirmCancel: '取消',
      branchConfirmHint: '儲藏可還原（git stash pop）；捨棄將永久刪除這些檔案（包含未追蹤檔案）。',
      branchSwitchError: '切換分支失敗',
      goalStatusActive: '進行中',
      goalStatusCompleted: '已完成',
      goalStatusBlocked: '受阻',
      goalStarted: '開始於',
      goalElapsed: '已用時',
      goalEdit: '編輯',
      goalEditTitle: '編輯目標',
      goalClear: '清除目標',
      goalSaveFailed: '儲存目標失敗',
      goalTokens: '{used} tokens',
      goalTokensK: '{k}k tokens',
      durationSeconds: '{n}秒',
      durationMinutes: '{m}分{s}秒',
      durationHours: '{h}小時{m}分',
      commonTokens: '{used} tokens',
      commonLoading: '載入中…',
      commonClose: '關閉',
      commonCancel: '取消',
      commonSave: '儲存',
      commonDone: '完成',
      commonEnable: '啟用',
      commonDisable: '停用',
      commonRecommended: '推薦',
    },
    list: {
      title: '裝置',
      subtitle: '連線到你帳號的 jcode 裝置。可以將工作傳送到任何一台線上機器。',
      emptyTitle: '尚無裝置',
      emptyBody: '在一台機器上執行 `jcode login`，將它連線到 jcode Cloud。',
      online: '線上',
      offline: '離線',
      lastSeen: '上次上線 {time}',
      neverSeen: '從未上線',
      loadErrorTitle: '無法載入裝置',
      servicePrincipal: '裝置與使用者帳號綁定——請以使用者身份登入，而不是使用控制台服務權杖。',
      platformDesktop: '桌面端',
      platformCli: 'CLI',
      e2ee: '端對端加密',
      e2eeWithKeyGen: '端對端加密 · 金鑰世代 {gen}',
    },
    welcome: {
      back: '裝置',
      newSession: '新工作階段',
      composerPlaceholder: '向 jcode 提問…',
      send: '傳送',
      mode: '模式',
      sessions: '工作階段',
      sessionCount_one: '{count} 個工作階段',
      sessionCount_other: '{count} 個工作階段',
      noSessions: '還沒有工作階段——傳送一則訊息即可開始。',
      creating: '正在建立工作階段…',
      createSlow: '裝置回應較慢——工作階段稍後出現。',
      untitled: '未命名工作階段',
      offlineBanner: '此裝置已離線。重新連線前無法傳送訊息。',
      delete: '刪除裝置',
      deleteConfirm: '確定刪除 {name} 嗎？裝置將登出並停止同步，工作階段歷史保留在伺服器上。',
      deleted: '已刪除裝置 {name}',
      sessionDelete: '刪除工作階段',
      sessionDeleteRunning: '請先停止工作階段再刪除',
      sessionDeleteConfirm: '確定從桌面端和雲端刪除「{name}」嗎？',
      sessionDeleted: '已刪除工作階段「{name}」',
      status: {
        idle: '閒置',
        running: '執行中',
      },
    },
    session: {
      back: '返回裝置',
      thinking: '思考中',
      thinkingAria: '思考中…',
      you: '你',
      send: '傳送',
      stop: '停止',
      composerPlaceholder: '傳訊息給 jcode…',
      offlineBanner: '裝置離線——重新連線前無法傳送。',
      streamError: '即時串流中斷——正在重新連線…',
      reconnect: '重新連線',
      approve: '批准',
      approveAll: '一律允許',
      deny: '拒絕',
      toolDenied: '已拒絕',
      askUser: 'jcode 提出了一個問題（在裝置上回答）：',
      agentStarted: 'Agent 已開始',
      agentDone: 'Agent 已完成',
      agentStopped: '已被使用者停止',
      agentFailed: 'Agent 失敗：{message}',
      taskRunning: '工作階段執行中',
      taskIdle: '工作階段閒置',
      modeChanged: '模式已切換為 {mode}',
      modelChanged: '模型已切換為 {model}',
      sessionReset: '工作階段已重置',
      todoUpdated: 'Todos 已更新',
      goalUpdated: '目標已更新：{objective}',
      goalCleared: '目標已清除',
      subagentStarted: '子 agent {name} 已開始',
      subagentDone: '子 agent {name} 已完成',
      subagentFailed: '子 agent {name} 失敗',
      sendFailed: '無法傳送：{message}',
      deviceOffline: '裝置已離線',
      emptyHistory: '此工作階段還沒有事件。',
      source: {
        console: '主控台',
        mobile: '行動端',
        desktop: '桌面端',
        wechat: '微信',
        local: '本機',
      },
    },
    guide: {
      entry: '使用指南',
      title: 'jcode 裝置使用指南',
      subtitle: '如何用 `jcode login` 接入一台機器，並從瀏覽器或手機 app 遠端使用它。',
      back: '返回裝置列表',
      shots: {
        devices: '雲控制台中的裝置列表',
        welcome: '裝置頁：發起新工作階段、瀏覽已有工作階段',
        session: '從裝置即時推送的工作階段',
        offline: '裝置離線時仍可檢視歷史',
        login: '手機 app 的登入畫面',
      },
      what: {
        title: '什麼是「裝置」？',
        p1: '裝置是一台執行 jcode（CLI 或桌面版）並透過 `jcode login` 登入 jcode Cloud 的機器。接入後，你可以從雲控制台或手機 app 遠端檢視和操作這台機器。',
        p2: '雲端只做中繼：你的機器主動向雲端發起連線，無需開放入站埠或 VPN。工作階段始終在你的機器上執行並保存。',
      },
      quickstart: {
        title: '快速上手',
        p1: '在你要控制的機器上執行：',
        code1: 'jcode login',
        p2: 'CLI 會印出一個驗證碼和一個確認連結——在瀏覽器裡確認登入。隨後裝置會自動連線，並出現在你的裝置列表中。',
        p3: '預設登入 https://cloud.j-code.net。self-host 時傳入你的雲端網址——必須使用 https（僅 localhost 開發場景允許 http）：',
        code2: 'jcode login --cloud https://your-cloud.example.com',
      },
      remote: {
        title: '遠端使用裝置',
        p1: '開啟裝置列表，點進一台裝置：可以發起新工作階段、即時跟進進行中的工作階段、停止執行、處理權限審批——和在機器本機上操作一致。',
        p2: '裝置離線時仍可翻看工作階段歷史，但傳訊息和審批會被停用，直到裝置重新上線。',
      },
      pairing: {
        title: '配對與端到端加密',
        p1: '工作階段內容端到端加密：雲端只存密文和路由元資料，無法讀取你的工作階段。新用戶端（新瀏覽器或手機）必須先與裝置配對，才能解密任何內容。',
        p2: '在瀏覽器或手機端發起配對，然後開啟裝置上的 jcode Desktop，進入「設定 → 雲端」，核對用戶端名稱，並在 10 分鐘內批准或拒絕。CLI 仍可用於自動化：',
        code1: 'jcode cloud pairings',
        code2: 'jcode cloud approve <pairing_id>',
        p3: '建議在 Desktop 的「設定 → 雲端」中審核。自動化場景可用 `pairings` 查看待處理請求，再用 `approve` 批准（拒絕對應 `jcode cloud deny <pairing_id>`）。',
      },
      keys: {
        title: '金鑰與復原',
        p1: '加密金鑰（CEK）在你的第一台裝置上生成，永不明文離開你的裝置。請備份一次 24 詞復原短語並妥善保管：',
        code1: 'jcode cloud key show-phrase',
        p2: '如果所有裝置都遺失，在新登入的裝置上用短語復原金鑰：',
        code2: 'jcode cloud key recover',
        p3: '需要更換金鑰時（已配對的用戶端需重新配對）：',
        code3: 'jcode cloud rotate-key',
      },
      commands: {
        title: '常用命令',
        p1: '以下命令都在裝置上執行：',
        rows: {
          login: '把本機登入 jcode Cloud（裝置碼流程）。',
          loginStatus: '顯示目前登入狀態並退出。',
          logout: '登出：吊銷裝置權杖並清除本機憑證。',
          cloudStatus: '顯示雲端網址、裝置 id、金鑰代數和連通性。',
          pairings: '列出用戶端發來的待批准配對請求。',
          approve: '批准一個配對請求（把加密後的金鑰交給用戶端）。',
          deny: '拒絕一個配對請求。',
          showPhrase: '顯示加密金鑰的 24 詞復原短語。',
          recover: '用復原短語重建加密金鑰。',
          rotateKey: '生成新金鑰（key_gen+1）；已配對用戶端需重新配對。',
        },
        e2eeNote: '端到端加密預設開啟。需要暫時關閉（明文上行，用於排查）時，在 `~/.jcode/config.json` 中設定 "cloud": { "e2ee": false } 並重新啟動 `jcode web`。',
      },
    },
    pairing: {
      start: '配對此用戶端',
      requests: {
        title: '配對請求',
        body: '此已批准用戶端可以安全地批准其他瀏覽器或手機。',
        approve: '批准',
        deny: '拒絕',
        approvalLost: '此用戶端已不再獲批，請先重新配對。',
      },
      idle: {
        title: '尚未設定端對端加密',
        body: '請從目前用戶端發起配對。請求會出現在 jcode Desktop 的「設定 → 雲端」中；在那裡批准前，加密工作階段內容會保持鎖定。',
      },
      pending: {
        title: '等待裝置上批准',
        body: '請開啟裝置上的 jcode Desktop，進入「設定 → 雲端」，核對目前用戶端，並在 10 分鐘內批准或拒絕此請求。',
      },
      denied: {
        title: '配對已被拒絕',
        body: '裝置拒絕了此配對請求。如是誤操作，請重新發起。',
      },
      expired: {
        title: '配對已過期',
        body: '配對請求未在 10 分鐘內獲得批准，請重新發起。',
      },
      gate: {
        title: '需要配對',
        body: '此裝置已強制啟用端對端加密。配對完成前，工作階段內容與控制無法使用。',
      },
      error: {
        title: '配對失敗',
        body: '配對過程中出現問題，請重試。',
      },
    },
    securityEyebrow: '裝置登入',
    title: '授權裝置',
    lede: 'jcode Desktop 正在請求登入此雲端。輸入 Desktop 中顯示的驗證碼以繼續。',
    safetyTitle: '僅批准由你發起的請求',
    enterTitle: '輸入 Desktop 中的驗證碼',
    codeLabel: '裝置驗證碼',
    codeHint: 'jcode Desktop 中顯示的 8 位驗證碼，形如 XXXX-XXXX。',
    codeCell: '第 {n} 個字元，共 {total} 個',
    codeRequired: '請輸入 jcode Desktop 顯示的驗證碼。',
    continue: '繼續',
    confirmTitle: '這是你的裝置嗎？',
    confirmBody: '僅當此驗證碼與 jcode Desktop 目前顯示的登入請求一致時才批准。',
    approve: '批准',
    deny: '拒絕',
    approvedTitle: '裝置已批准',
    approvedBody: '請返回 jcode Desktop，登入將自動完成。',
    deniedTitle: '裝置已拒絕',
    deniedBody: '登入請求已被拒絕，jcode Desktop 將停止等待。',
    another: '授權另一台裝置',
    unavailableTitle: '該登入請求已不可用',
    tryAnotherCode: '輸入其他驗證碼',
    backToDevices: '返回裝置列表',
    errorNotFound: '沒有與該驗證碼匹配的待處理登入——它可能已過期。請從 jcode Desktop 重新發起登入。',
    errorAlreadyDecided: '該登入請求已被批准或拒絕。',
    errorGeneric: '無法授權裝置，請重試。',
  },

  projectDetail: {
    promptRequired: '請描述要交給 agent 的工作。',
    sessionStarted: '工作階段已開始。',
    startRunFailed: '無法開始執行。',
    defaultModelUpdated: '已更新預設模型。',
    defaultModelFailed: '無法設定預設模型。',
	runnerProfileUpdated: '已更新執行環境設定。',
	runnerProfileFailed: '無法設定執行環境設定。',
    repoAdded: '已新增儲存庫「{name}」。',
    addRepoFailed: '無法新增儲存庫。',
    nameRequired: '名稱為必填。',
    repoUrlRequired: '儲存庫 URL 為必填。',
    draftPrNeedsProviderUrl: '草稿 PR 需要供應商的儲存庫 URL。',
    loadingProject: '正在載入專案…',
    loadFailedTitle: '無法載入專案',
    projects: '專案',
    cluster: 'Cluster',
    projectWorkspace: '專案工作區',
    addService: '新增服務',
    deleteService: '刪除服務',
    deleteServiceAria: '刪除服務 {name}',
    deleteServiceConfirm: '刪除服務「{name}」？執行中的工作會先停止，接著永久刪除該服務的所有工作、事件、產物、自動化與工作區資源。此操作無法復原。',
    serviceDeleted: '服務「{name}」已刪除。',
    deleteServiceFailed: '無法刪除服務。',
    breadcrumb: '麵包屑導覽',
    backToWorkspace: '返回專案工作區',
    projectSettings: '專案設定',
    kanban: 'Agent Board',
    kanbanRetryTitle: '無法載入 Kanban 連結。請重試。',
    kanbanUnavailableRetry: 'Kanban 無法使用 · 重試',
    demoTag: 'DEMO',
    noRepositoriesYet: '尚無服務',
    repositoriesCount_one: '{count} 個儲存庫',
    repositoriesCount_other: '{count} 個儲存庫',
    openProvider: '開啟 {provider}',
    repoUrlUnresolved: '伺服器無法解析此供應商儲存庫的瀏覽器 URL。',
    repositoryUnavailable: '儲存庫無法使用',
    addRepoEmptyTitle: '新增服務以開始',
    addRepoEmptyManage: '服務會將專案連接到 Git 儲存庫，並作為執行目標。',
    addRepoEmptyMember: '專案擁有者需先新增服務，才能派發執行。',
    firstServiceEyebrow: '專案初始化',
    firstServiceAction: '連接第一個儲存庫',
    firstServiceSetupTitle: '新增第一個服務',
    firstServiceSetupDescription: '選擇一個儲存庫。連接後，它會成為任務和自動化的執行目標。',
    source: '來源',
    directCredential: '直接（你的憑證）',
    gitProvider: 'Git 供應商',
    pickRepository: '選擇儲存庫',
    searchRepositories: '搜尋儲存庫…',
    loadingRepositories: '正在載入儲存庫…',
    listReposFailed: '無法列出 {source} 的儲存庫。',
    integrationSource: '整合',
    addRepoByUrlInstead: ' 請改為在下方以 URL 新增儲存庫。',
    noRepositoriesMatch: '沒有符合的儲存庫。',
    private: '私有',
    orAddByUrl: '或以 URL 新增',
    repositoryName: '儲存庫名稱',
    repositoryUrl: '儲存庫 URL',
    addRepository: '新增儲存庫',
    memberNeedsIntegration: '新增服務前，請先連接並啟用 GitHub、GitLab 或 Gitea 專案外掛。',
    configureProjectPlugins: '設定專案外掛',
    automationsMembersTitle: '自動化開放給專案成員使用',
    automationsMembersDesc: '你可以檢視工作歷史，但排程與供應商事件必須由專案成員管理。',
    automationsNeedServiceTitle: '自動化需要服務',
    automationsNeedServiceDesc: '請先連接儲存庫；排程與供應商事件的範圍限定於服務。',
  },

  plugins: {
    title: '外掛', projectPlugin: '專案外掛', intro: '每個專案只需連接一次供應商。健康且已啟用的外掛可供專案中的每個任務使用。',
    readOnly: '只有專案擁有者或 Cluster 管理員可以變更外掛連接。', loading: '正在載入外掛…', loadError: '無法載入外掛。',
    notConnected: '未連接', connect: '連接', connectError: '無法啟動供應商連接。', summary: '{services} 個服務 · {automations} 個自動化',
    back: '返回外掛', identity: '已連接身分', scopes: '已授予存取權', noScopes: '目前未授予供應商存取權。',
    resources: '資源', noResources: '尚未綁定專案資源。', automationSummary: '自動化', openAutomations: '開啟自動化', audit: '連接稽核',
    noAudit: '尚未記錄稽核事件。', reconnect: '重新連接', stableId: '穩定 ID：{id}', consentRecorded: '同意版本 {version} · {time}', unknown: '未知',
    resourcesLoadError: '無法列出供應商資源。', boundWorkspace: '綁定的工作區', selectWorkspace: '選擇工作區…', workspaceSetupHint: '選擇工作區會完成 JType 外掛設定並啟用它。',
    workspace: '工作區', columns: '{count} 欄', private: '私人', public: '公開', defaultBranchUnknown: '預設分支未知', services: '關聯服務',
    noServices: '沒有服務綁定到此外掛。', noAutomations: '沒有自動化依賴此外掛。', auditLoadError: '無法載入外掛稽核記錄。', auditLoading: '正在載入稽核記錄…',
    impactLoading: '正在載入影響範圍…', impactLoadError: '無法載入影響範圍。', impactSummary: '{services} 個服務和 {automations} 個自動化將被永久刪除。',
    forceUninstall: '僅在供應商 Webhook 清理失敗時強制本機移除。這可能留下外部 Webhook。',
    enable: '啟用外掛', disable: '停用外掛', uninstall: '解除安裝外掛', uninstallHint: '解除安裝會在完成外部清理後永久移除相依的服務與自動化。', uninstallTitle: '解除安裝 {provider}？', uninstallConfirm: '此操作無法復原。外掛在本機移除後，外部 Webhook 清理可能仍會繼續。', uninstallType: '輸入 UNINSTALL 以確認', invalidProvider: '此供應商外掛不存在。',
    consentTitle: '連接 {provider}', consentIntro: '繼續前，請檢視此連接將授予 jcode Cloud 的專案層級存取權。', consentScope: '供應商將要求此外掛所需的程式碼、分支、合併請求、Issue、留言、檢查、標籤、發佈與 Webhook 存取權。', consentShared: '權杖會成為專案共用憑證，而非安裝者的個人憑證。', consentTasks: '所有專案任務都會取得每個已啟用的外掛，包括此項。', consentPersistence: '即使安裝者離開專案，此連接仍會持續，直到斷開或由供應商撤銷。', consentPublic: '在公開儲存庫中，一條 @jcode 留言可啟動取得專案全部已啟用外掛憑證的任務。', consentAcknowledge: '我理解並同意此專案層級存取權。', continueToProvider: '繼續前往供應商',
    incompleteResponse: '供應商傳回的連接回應不完整。',
    providerInstance: '供應商執行個體', configuredClusterInstance: 'Cluster 中設定的執行個體', requestedScopes: '要求的權限範圍',
    githubChooseInstallation: '選擇 GitHub App Installation',
    githubChooseInstallationHint: '同意前請選擇一個 Installation 並檢查其實際權限。此選擇僅用於目前專案，系統不會自動跨專案重複使用。',
    githubInstallationsLoading: '正在載入 GitHub Installations…', githubInstallationsLoadError: '無法列出 GitHub Installations。',
    githubInstallationSummary: '{target} · {selection} 儲存庫',
    githubTarget: { organization: '組織', user: '使用者' }, githubSelection: { selected: '選定範圍', all: '全部' },
    githubInstallationsEmpty: '找不到你可管理的 GitHub App Installation。請在 GitHub 安裝該 App 或調整儲存庫範圍，然後重試。',
    githubActualPermissions: '{account} 的實際權限',
    githubPermissionsAcknowledge: '我已檢查這些 GitHub App 實際權限，並接受上述專案層級憑證風險。',
    githubConnectInstallation: '連接此 Installation',
    jtypeApprove: '在 JType 中核准', jtypeApproveHint: '使用驗證碼 <code>{code}</code>。此對話框會持續檢查，直到 JType 確認授權。',
    jtypeOpenConsent: '開啟 JType 同意頁面', jtypeStatusLoadError: '無法檢查 JType 連接狀態。',
    connectionStatusLabel: '狀態：{status}',
    connectionStatus: { pending: '等待核准', complete: '已完成', expired: '已過期', denied: '已拒絕', unsupported: '不支援', checkFailed: '無法檢查狀態' },
    coarseScope: {
      gitlab: 'GitLab 的粗粒度 api scope 可能允許比此外掛通常所需範圍更廣的 API 讀寫操作，包括你的外部角色可修改的儲存庫設定。jcode 沒有能從技術上阻止所有破壞性 API 呼叫的命令白名單。',
      gitea: '依執行個體版本和你的外部角色，Gitea 的粗粒度 write:repository scope 可能允許修改儲存庫設定及執行超出一般任務流程的破壞性操作。jcode 沒有命令白名單。',
      jtype: 'JType full scope 允許對所選雲端工作區執行所有支援的讀寫操作，並不僅限於 Kanban 觸發。',
    },
    healthError: {
      jtypeStartFailed: '無法啟動 JType 裝置授權。',
      webhookCleanupFailed: '供應商 Webhook 清理失敗。請重試解除安裝，或明確強制本機移除並接受可能遺留外部 Webhook。',
      runtimeCleanupFailed: '執行階段清理失敗。請在 Cluster 恢復健康後重試解除安裝。',
      oauthRefreshFailed: 'OAuth 存取權已過期且重新整理失敗，請重新連接此外掛。',
      providerConfigChanged: 'Cluster 供應商設定已變更，請重新連接此專案外掛。',
    },
    apiError: {
      githubAppNotConfigured: 'GitHub App 尚未完整設定。請讓 Cluster 管理員填入 App ID、私鑰與 Webhook Secret。',
      githubIdentityRequired: '請使用可管理此 App Installation 的 GitHub 帳號登入。',
      githubInstallationForbidden: '目前 GitHub 帳號無法管理所選 App Installation。',
      githubAppError: 'GitHub 無法驗證所選 App Installation，請重試。',
      consentScopeChanged: 'GitHub App 權限已變更，請重新檢查目前權限並同意。',
      providerNotConfigured: '此供應商外掛尚未在 Cluster 中設定或啟用。',
      credentialUnavailable: '外掛憑證不可用，請重新連接外掛。',
      reconnectRequired: '外掛設定已變更或授權已過期，請重新連接外掛。',
      connectExpired: '連接要求已過期，請重新開始連接。',
      workspaceUnavailable: '目前授權無法存取所選 JType 工作區。',
      workspaceRequired: '啟用此外掛前，請先選擇 JType 工作區。',
      webhookCleanupFailed: '供應商 Webhook 清理失敗。請重試解除安裝，或明確強制本機移除。',
      runtimeCleanupFailed: '執行階段清理失敗，請在 Cluster 恢復健康後重試。',
      connectUnsupported: '目前不支援此供應商的連接流程。',
      encryptionUnavailable: 'Cluster 加密金鑰尚未設定，請聯絡 Cluster 管理員。',
      consentRequired: '連接前請檢查並同意目前的專案外掛授權說明。',
      providerUnavailable: '供應商無法完成此要求。請檢查可用性與權限後重試。',
      generic: '無法完成外掛操作，請重試。',
    },
    auditEvent: {
      consent_accepted: '已同意授權', connected: '已連接', reconnected: '已重新連接', reconnect_started: '已開始重新連接',
      configuration_changed: '設定已變更', uninstall_cleanup_failed: '解除安裝清理失敗', uninstalled: '已解除安裝', force_uninstalled: '已強制解除安裝',
    },
    status: { not_connected: '未連接', connecting: '連接中', enabled: '已啟用', disabled: '已停用', action_required: '需要操作', uninstalling: '解除安裝中', error: '錯誤' },
    trigger: { scm: 'SCM 事件', kanban: 'Kanban 欄', cron: '排程任務' },
    systemActor: '系統',
  },

  automationEditor: {
    loading: '正在載入自動化…', loadError: '無法載入自動化。', eyebrow: '儲存庫自動化', createTitle: '建立自動化', editTitle: '編輯自動化',
    subtitle: '為此儲存庫綁定一個強型別觸發器。', viewerWarning: '檢視者可以檢查設定，但不能儲存自動化。',
    task: '任務', name: '名稱', service: '儲存庫', selectService: '選擇儲存庫…', serviceUnavailable: '儲存庫無法使用',
    model: '模型', selectModel: '選擇模型…', effort: '推理強度', effortAuto: '自動', effortLow: '低', effortMedium: '中', effortHigh: '高',
    effortHint: '此模型宣告支援推理強度設定。', promptTemplate: '提示詞範本',
    enabled: '已啟用', ignoreJcode: '忽略由 jcode 建立的事件', trigger: '觸發器', scm: 'SCM', cron: 'Cron',
    selectGitService: '請連接 GitHub、GitLab 或 Gitea 儲存庫。', capabilitiesLoadError: '無法載入供應商能力。',
    branchFilter: '分支篩選', branchPlaceholder: 'main 或 feature/*', branchHint: '適用於包含分支資訊的 Push、PR 與 Check 事件。',
    pathPattern: '路徑模式', pathHint: '僅當所有選取事件都是 push.updated 時可用。',
    conclusion: 'CI 結果', conclusionHint: '僅當所有選取事件都是 check.completed 時可用。',
    events: '事件', moreEvents: '更多事件', thisProvider: '目前供應商', eventUnavailable: '{provider}{version} 不支援此事件。',
    cronExpression: 'Cron 表達式', cronHint: '使用五段式 Cron 表達式；伺服器會強制執行最小時間間隔。',
    outputMode: '輸出方式', outputRun: '直接建立 Run', outputCard: '先建立 jtype Card，再由 Agent Board 執行',
    outputHint: 'Card 輸出會保留 jtype 工作項目，並沿用標準看板受理與回寫閉環。',
    openBoardSettings: '開啟 Agent Board 設定',
    outputCardUnavailable: '請先連接健康的 Agent Board，再選擇 Card 輸出。',
    create: '建立自動化', save: '儲存自動化',
    review: {
      eyebrow: 'GitHub 程式碼審查', title: '審查 Pull Request', subtitle: '無需讓團隊學習新流程，即可啟用實用的 GitHub 原生審查。',
      defaultName: 'Pull Request 審查', setup: '審查設定',
      automaticTitle: '預設自動審查', automaticBody: 'Pull Request 準備好後，App 會自動審查；後續每次提交新程式碼也會再次審查。',
      repeatTitle: '直接從 GitHub 重複審查', repeatBody: '將此命令貼到任意 Pull Request 留言中。GitHub 的 @ 自動完成可能不顯示自訂 App，但完整命令可以正常觸發。',
      focus: '審查重點（選填）', focusPlaceholder: '例如：特別留意授權邊界。', focusHint: '審查器始終會檢查正確性、安全性、可靠性、資料遺失和回歸。',
      when: '何時審查', readyTitle: '已準備好的 Pull Request', readyBody: '審查新建的 Pull Request，以及從草稿轉為準備好的 Pull Request。',
      updatesTitle: '有新提交時', updatesBody: 'Pull Request 的最新提交發生變化時重新審查。',
      draftsTitle: '包含草稿', draftsBody: '通常保持關閉，讓作者先完成自己的第一輪檢查。',
      create: '開啟審查', save: '儲存審查設定',
    },
    validation: { noPermission: '你沒有編輯自動化的權限。', required: '名稱、儲存庫、模型與任務提示詞都是必填項目。', eventRequired: '請至少選擇一個此儲存庫供應商支援的事件。', cronRequired: 'Cron 表達式為必填項目。', cardOutputUnavailable: 'Card 輸出需要健康的 Agent Board 策略。' },
    apiError: {
      overlap: '此儲存庫的另一個自動化已使用所選 SCM 事件中的至少一個。',
      webhook: '自動化已儲存，但無法同步供應商 Webhook。請檢查外掛連接後重試。',
      pluginUnavailable: '所選儲存庫連線不可用，或不支援此觸發器。',
      modelUnavailable: '所選模型已無法供此帳號使用，請選擇其他模型。',
      modelRequired: '請選擇已授權給此帳號的模型。',
      effortUnsupported: '所選模型不支援推理強度，請使用「自動」或選擇推理模型。',
      generic: '無法儲存自動化，請重試。',
    },
  },

  automationExecutions: {
    loading: '正在載入自動化…', loadError: '無法載入自動化。', back: '返回自動化列表',
    cardOutput: 'Card 輸出', runOutput: '直接 Run 輸出', runNow: '立即執行',
    runNowError: '本次執行未能受理；重試會沿用同一個冪等鍵。',
    history: '執行歷史', loadingHistory: '正在載入執行歷史…', historyError: '無法載入執行歷史。',
    empty: '尚無執行記錄。', loadMore: '載入更早的執行', select: '選擇一筆執行記錄查看詳情。',
    selected: '選取的執行', execution: '執行', trigger: '觸發來源', kind: '類型',
    requested: '請求者', accountable: '負責人', notApplicable: '不適用', unattributed: '未歸因',
    output: '輸出', expected: '預期', cardThenRun: 'jtype Card → 看板 Run', directRun: '直接 Run',
    actual: '實際結果', writeback: '回寫', usage: '用量', usageUnavailable: '暫不可用',
    filter: { all: '全部', blocked: '受阻', running: '執行中', terminal: '已結束' },
    state: {
      accepted: '已受理', ignored: '已忽略', duplicate: '重複',
      superseded: '已取代', blocked: '受阻', queued: '排隊中',
      running: '執行中', terminal: '已結束',
    },
    outcome: { succeeded: '成功', failed: '失敗', canceled: '已取消' },
    repair: {
      project_owner: '專案擁有者可以修復此依賴。',
      repository_owner: '儲存庫擁有者可以修復此依賴。',
      cluster_admin: '需要叢集管理員修復此依賴。',
      requester: '需要請求者修復此依賴。',
    },
    title: {
      blocked: '在產生輸出前受阻', ignored: '觸發已依規則忽略',
      card: 'Card 輸出', run: 'Run 輸出',
    },
  },

  projectAutomations: {
    eyebrow: '儲存庫自動化', title: '自動化', subtitle: '為此儲存庫建立 SCM 與排程工作。Agent Board 從儲存庫標題區域設定。',
    loading: '正在載入自動化…', loadError: '無法載入自動化。', new: '新增自動化', noServices: '建立自動化前請先連接儲存庫。',
    filters: '自動化篩選', all: '全部', empty: '目前檢視中沒有符合的自動化。', edit: '編輯', delete: '刪除',
    back: '返回自動化', newTitle: '新增自動化', editTitle: '編輯自動化', name: '名稱', triggerLabel: '觸發器類型',
    cron: 'Cron 表達式', action: 'SCM 事件', column: '觸發欄', prompt: '任務說明', incomplete: '儲存前請填寫所有必填項目。',
    create: '建立自動化', save: '儲存變更', trigger: { scm: 'SCM 事件', kanban: 'Kanban 欄', cron: '排程任務' },
    enabled: '已啟用', disabled: '已停用', toggleLabel: '{name}：{status}',
    review: { turnOn: '審查 Pull Request', manage: '審查設定', rowSummary: '由 GitHub App 在變更行上發布高可信度問題。', native: 'GitHub 原生審查' },
    error: {
      modelUnavailable: '收到此事件時無法選擇可用模型。請為帳號授權模型；若有多個可用模型，請設定儲存庫預設模型。下次成功觸發後會自動清除此歷史錯誤。',
      modelNotSelected: '有多個可用模型，但此儲存庫沒有預設模型。請在儲存庫設定中選擇一個。',
      modelNotConfigured: '此帳號沒有獲授權的模型。請讓 Cluster 管理員授權一個模型。',
      modelTemporary: '因暫時性內部錯誤，無法讀取模型設定。請重新觸發。',
      triggerUnavailable: '此自動化的觸發設定不可用，請重新儲存自動化。',
      serviceUnavailable: '此自動化關聯的儲存庫不可用。',
      repositoryUnavailable: '此儲存庫連線不可用。請重新連接供應商。',
      runCreateFailed: '事件已符合，但無法建立自動化任務。',
      invalidCron: 'Cron 表達式無效：{expression}',
      dispatchFailed: '排程自動化無法建立任務。',
      webhookReconcileFailed: '無法同步 SCM Webhook。請檢查外掛憑證與供應商 Webhook 權限，然後重新儲存自動化。',
    },
  },

  projectSettings: {
    navGeneral: '一般',
    navMembers: '成員',
    navPlugins: '外掛',
    navModels: '模型存取',
    navApiKeys: 'API 金鑰',
    envInvalidName: '「{key}」不是有效的環境變數名稱。',
    envReserved: '「{key}」已由協調器保留，無法設定。',
    projectUpdated: '已更新專案「{name}」。',
    updateFailed: '無法更新專案。',
    projectDeleted: '已刪除專案「{name}」。',
    deleteFailed: '無法刪除專案。',
    eyebrow: '專案管理',
    title: '設定',
    subtitle: '管理專案容器。儲存庫行為的範圍仍限定於各服務。',
    navAria: '專案設定區段',
    generalDesc: '專案識別與執行防護欄。',
    projectName: '專案名稱',
    projectNameHintPage: '儲存庫分支與 git 模式依各服務設定。',
    executionGuardrails: '執行防護欄',
    guardrailBlankHint: '將限制留空以繼承 Cluster 預設值。',
    maxConcurrent: '最大並行執行數',
    clusterDefaultPlaceholder: 'Cluster 預設值',
    runTimeout: '執行逾時（秒）',
    injectedEnv: '注入的環境變數',
    injectedEnvHintPage: '會合併進每次執行。系統變數為保留變數。',
    removeVariable: '移除變數',
    addVariable: '新增變數',
    membersTitle: '成員與權限',
    membersDesc: '選擇誰可以檢視、執行與管理此專案。',
    pluginsTitle: '外掛',
    pluginsDesc: '專案共用的原始碼管理與看板連線。',
    modelsDesc: '此專案的工作階段目前可用的模型。',
    apiKeysTitle: '專案 API 金鑰',
    apiKeysDesc: '用於 API 觸發自動化的可撤銷憑證。',
    dangerTitle: '危險區域',
    dangerDesc: '永久性、破壞性的專案操作。',
    deleteProject: '刪除專案',
    deleteHintPage: '永久移除此專案及其所有執行、事件與產物。',
    deleteForGood: '永久刪除？',
    savebarHint: '專案設定與服務設定分開儲存。',
    saveChanges: '儲存變更',
    loadingModelAccess: '正在載入模型存取…',
    modelAccessLoadError: '無法載入模型存取。請從專案工作區重試。',
    noModelConfigured: '此專案尚未設定任何模型。請 Cluster 管理員授權一個。',
    granted: '已授權',
    envFallbackActive: 'Cluster 環境模型備援已啟用。',
    models: {
      ownedTitle: '專案模型供應商',
      ownedDescription: '為此專案接入自有的供應商，並選擇可執行的模型。',
      addProvider: '新增供應商',
      providersSummary: '{providers} 個供應商 · {models} 個模型',
      noProviders: '尚無專案模型供應商。',
      noProvidersHint: '新增供應商，為此專案設定專屬模型。',
      enableAria: '啟用 {name}',
      disableAria: '停用 {name}',
      editModelAria: '編輯 {name}',
      deleteModelAria: '移除 {name}',
      removeModelConfirm: '移除 {name}？',
      modelRemoved: '模型已移除。',
      removeModelError: '無法移除該模型。',
      updateModelError: '無法更新該模型。',
      clearHeadersAction: '移除已設定的 Header',
      clearHeadersPending: '儲存後將移除已設定的 Header · 點擊復原',
      editDialogTitle: '編輯模型 · {name}',
      saveModel: '儲存模型',
      modelSaved: '模型已儲存。',
      saveModelError: '無法儲存該模型。',
      availableTitle: '可用模型',
      defaultTitle: '專案預設模型',
      defaultDescription: '當自動化或服務未選擇更具體的模型時使用。',
      noDefault: '不設定專案預設模型',
      availableOwnerHint: '此專案可執行的全部模型 — 包含自有模型以及 Cluster 管理員授予的模型。',
      availableMemberHint: 'Cluster 管理員或專案擁有者已為此專案提供的模型。',
    },
    name: '名稱',
    guardrails: '防護欄',
    apiKeyCreated: '已建立 API 金鑰「{name}」。',
    apiKeyCreateFailed: '無法建立 API 金鑰。',
    apiKeyRevoked: '已撤銷 API 金鑰。',
    apiKeyRevokeFailed: '無法撤銷 API 金鑰。',
    apiKeyIntro1: '專案範圍的金鑰會以 ',
    apiKeyIntro2: ' 的身分驗證，且僅能觸發執行並讀取此專案 — 絕不能存取其他專案、此專案的設定或成員，也絕不能存取 Cluster 管理員介面。請將它用於外部/CI 自動化，而非 Cluster 範圍的主控台權杖。',
    apiKeysEmpty: '尚無 API 金鑰 — 請在下方建立一個。',
    apiKeyNameHint: '有助你日後區分金鑰 — 請取一個可辨識的名稱，例如將使用它的 CI 工作。',
    createKey: '建立金鑰',
    apiKeyRevealTitle: '已建立「{name}」',
    apiKeyRevealHint: '僅顯示一次 — 請立即複製。它無法再次顯示；若遺失，請撤銷此金鑰並建立新的。',
    statusRevoked: '已撤銷',
    statusActive: '使用中',
    createdAt: '建立於 {time}',
    lastUsed: ' · 上次使用於 {time}',
    neverUsed: ' · 從未使用',
    revoke: '撤銷',
  },

  projectWorkspace: {
    railServicesAria: '專案服務',
    projectEyebrow: '專案',
    serviceCount_one: '{count} 個服務',
    serviceCount_other: '{count} 個服務',
    servicesHeading: '服務',
    noServiceConnected: '尚未連接任何服務。',
    workspaceAria: '{projectName} 工作區',
    tabsAria: '專案工作區區段',
    tabTasks: '工作',
    tabAutomations: '自動化',
    tabServiceSettings: '服務設定',
  },

  taskComposer: {
    eyebrow: '新增工作',
    heading: '在 {name} 中開始工作階段',
    isolation: '在隔離的工作區中執行',
    messageAria: '訊息',
    placeholder: '描述要完成的工作…',
    permissionModeAria: '權限模式',
    permissionModeTitle: '完全存取會自動核准 agent；動作前詢問會在時間軸中暫停以等待你的核准。',
    fullAccess: '完全存取',
    askBeforeActions: '動作前詢問',
    session: '工作階段',
    modelAria: '模型',
    serviceDefault: 'Repository 預設值',
    serviceDefaultWithModel: 'Repository 預設值 · {model}',
    branchAria: '基底分支',
    branchDefault: '預設',
	branchLoading: '正在載入分支…',
    branchUnavailable: '無法重新整理分支。請修復 Plugin 連線後重試。',
    effortAria: '推理強度',
    effortAuto: '推理 · 自動',
    effortLow: '推理 · 低',
    effortMedium: '推理 · 中',
    effortHigh: '推理 · 高',
    add: '新增',
    addMenu: '新增至工作',
    goalMode: 'Goal 模式',
    goalPlaceholder: '描述需要持續推進的目標…',
    goalModeHint: '下一項工作將作為持續執行的 Goal 啟動。',
    disableGoalMode: '關閉 Goal 模式',
    attachments: '附件',
    addAttachments: '新增附件',
    removeAttachment: '移除 {name}',
    attachmentTooMany: '最多可新增 {max} 個附件。',
    attachmentTooLarge: '{name} 超過 25 MiB。',
    attachmentTotalTooLarge: '每次執行的附件總大小不可超過 {max} MiB。',
    attachmentUploadFailed: '附件上傳失敗。',
    send: '傳送',
  },


  settingsPanel: {
    emptyTitle: '設定需要 Repository',
    emptyDescription: '請先連接儲存庫，再設定其模型政策。',
    eyebrow: 'Repository 設定',
    description: '此 Repository 的執行政策；供應商連接會分別管理。',
    source: '來源',
    provider: '供應商',
    defaultBranch: '預設分支',
    gitMode: 'Git 模式',
    gitModeDraftPr: '草稿 pull request',
    gitModeReadOnly: '唯讀',
    modelPolicyEyebrow: '模型政策',
    modelPolicyTitle: 'Repository 預設模型',
    modelPolicyDescription: '只有當工作編寫器將每次執行的選擇保持在「Repository 預設值」時，才會使用此設定。',
    modelsLoading: '正在載入帳號模型權限…',
    modelsUnverified: '無法驗證此帳號的模型權限。在模型目錄可用之前，請勿變更預設值。',
    retryModelCheck: '重試模型檢查',
    defaultModelAria: '此儲存庫的預設模型',
    noDefault: '無預設值',
    noModelGranted: '此帳號尚未獲授權任何模型。Cluster 管理員必須先授權一個，才能選擇 Repository 預設值。',
	runtimePolicyEyebrow: '執行環境政策',
	runtimePolicyTitle: 'Runner 環境',
	runtimePolicyDescription: '為此 Repository 的每次 Run 選擇由管理員維護的不可變工具鏈環境。',
	runnerProfileAria: '此儲存庫的 Runner 環境',
	runtimeProfilesUnavailable: '無法載入執行環境清單，目前 Repository 設定保持不變。',
  },

  webhook: {
    errSync: '無法同步供應商 Webhook。請重試或聯絡 Cluster 管理員。',
    eyebrowReview: 'PR 審查 Webhook',
    unavailableTitle: '供應商事件需要有供應商支援的儲存庫',
    pathOrUrlNote: '是路徑或原始 URL，因此無法接收 pull-request 或 merge-request 的留言事件。',
    readonlyTitle: '自動化對檢視者為唯讀',
    readonlyBody: '專案成員可以連接 {provider} 並同步此儲存庫的審查 Webhook。',
    oauthNotConfiguredTitle: '此 cluster 尚未設定 {provider} OAuth',
    oauthNotConfiguredBody: '請 Cluster 管理員設定 {provider} OAuth 與 Webhook 接收器。不會使用任何備援憑證。',
    serviceTitle: '必須由已登入的專案成員授權 {provider}',
    serviceBody: '主控台權杖工作階段沒有個人 OAuth 身分。請以專案成員帳號登入以同步此 Webhook。',
    eyebrowProvider: '供應商 Webhook',
    connectTitle: '連接 {provider} 以使用 PR 審查指令',
    connectBodyPre: '連接管理',
    connectBodyPost: ' 的帳號。jcode 會為此儲存庫請求 OAuth 權限；它絕不會要求你在此貼上個人存取權杖。',
    connectCta: '以 OAuth 連接 {provider}',
    readyTitle: '{provider} PR 審查指令',
    readyBodyPre: '同步會為',
    readyBodyMid: ' 註冊供應商的留言 Webhook，使用你的 {provider} OAuth 帳號。之後協作者即可使用 ',
    readyBodyPost: ' 開始審查。當儲存庫變更時再次執行也是安全的。',
    oauthConnected: 'OAuth 已連接。',
    synchronizing: '正在同步 Webhook…',
    setupReady: 'Webhook 設定已就緒。',
    syncedTo: 'Webhook 已同步至',
    syncButton: '同步 {provider} Webhook',
    reconnectOauth: '重新連接 OAuth',
  },

  runActivity: {
    eyebrow: '動態',
    title: '最近的工作',
    filtersAria: '篩選最近的工作',
    filterAll: '全部',
    filterSessions: '工作階段',
    filterReviews: '審查',
    loadingTasks: '正在載入工作…',
    errorTitle: '無法載入工作',
    emptyTitleAll: '尚無工作',
    emptyTitleFiltered: '此 Repository 沒有 {filter}',
    emptyDescDispatch: '使用上方的編寫器派發你的第一項工作。',
    emptyDescNone: '此專案尚未派發任何工作。',
    emptyDescFiltered: '請嘗試其他篩選條件或選擇不同的 Repository。',
    runAria: '{kind}：{summary} — {status}',
    retryTitle: '先前執行的重試',
    retryBadge: '重試',
  },

  projectSettingsAction: {
    label: '專案設定',
  },

  codeReviewsPage: { eyebrow: '獨立工作流程', title: 'Code reviews', description: '集中查看各 Repository 的 Review Run，並與開發任務分開。', createEyebrow: '新 Review', createTitle: '發起 Code review', createDescription: '選擇 Repository，以及由已完成 Cloud 任務建立的 Pull request。', loadingSources: '正在載入可 Review 的 Pull request…', sourcesError: '無法載入可 Review 的 Pull request。', noRepositories: '目前帳號沒有可用的 Repository。', connectRepository: '檢查 Git 帳號授權', repositoryLabel: 'Repository', pullRequestLabel: 'Pull request', noReviewablePr: '目前沒有可 Review 的 Cloud Pull request。', noReviewablePrDescription: '先從 Repository 任務建立 Pull request，然後返回這裡。', openWorkHome: '開啟 Work Home', openPullRequest: '開啟 Pull request', createAction: '建立 Code review', createSuccess: 'Code review 已開始。', createError: '無法開始 Code review。', emptyTitle: '尚無 Code review', emptyDescription: '所有 Repository 的 Review Run 會集中顯示在這裡。' },
  accountHeader: {
    location: '工作區位置',
    account: '帳號', menu: '帳號選單', codeReviews: '程式碼審查', settings: '帳號設定', clusterSettings: 'Cluster 設定', admin: '管理員', signOut: '登出',
  },
  accountSettings: {
    back: '返回工作台', eyebrow: '帳號', title: '帳號設定',
    description: '你的個人資料、模型授權、已連結的 Git 帳號、用量與偏好設定會套用至每個 Repository 和 jcode Desktop。',
    tabsAria: '帳號設定區段', profileTab: '個人資料', gitAccountsTab: 'Git 帳號', modelsTab: '模型', usageTab: '用量', preferencesTab: '偏好設定',
    profileTitle: '帳號資料', profileDescription: '這是執行 Repository 任務及擁有對話時使用的身分。',
    displayName: '顯示名稱', accountId: '帳號 ID', role: '角色', clusterAdministrator: 'Cluster 管理員', member: '成員', executionIdentity: '執行身分',
    repositoryOwnerDefault: '預設為 Repository owner', currentAccount: '目前帳號', sessionAccount: '工作階段帳號',
    gitAccountsTitle: 'Git 帳號', gitAccountsDescription: '這些已連結帳號可見的 Repository 會直接出現在 Work Home 的內容選擇器中。',
    repositoryAccessUnavailable: '此帳號目前無法存取 Repository。', connected: '已連結至此帳號', reauthorize: '重新授權 {provider}', linkProvider: '連結 {provider}',
    authorizeRepositories: '為此帳號授權 Repository', checkingRepositoryAccess: '正在檢查 Repository 存取權限…', repositoryAccessUnavailableTitle: 'Repository 存取不可用',
    modelsTitle: '模型與提供方', modelsDescription: '模型直接授權給你，並套用至每個 Repository。', loadingModels: '正在載入帳號模型…', modelAccessUnavailable: '模型授權不可用',
    noModels: '你的帳號尚未獲得模型授權。請聯絡 Cluster 管理員。', modelAuthorized: '帳號已授權', manageAuthorizations: '在 Cluster 設定中管理帳號授權',
    preferencesTitle: '偏好設定', preferencesDescription: '在支援的範圍內，Cloud 和 Desktop 使用相同的產品語言與視覺偏好。',
    language: '語言', languageDescription: '變更介面語言。', appearance: '外觀', appearanceDescription: '使用淺色或深色主題。',
  },
  repositories: {
    openRepository: '開啟儲存庫 {name}',
    toggleConversations: '展開或收合 {name} 的對話',
    conversationSection: '對話',
    navigationUnavailable: '此儲存庫無法使用。請檢查 Git 帳號授權，或選擇其他儲存庫。',
    remoteUnavailable: '此遠端裝置無法使用。請重新連線或選擇其他裝置。',

    eyebrow: '你的程式碼', title: 'Repositories',
    description: '一個 Repository 對應一個 Agent 工作區，包含 Board、任務、設定與 Code reviews。',
    composerEyebrow: '帳號工作區', composerTitle: '接下來想寫什麼？',
    composerDescription: '選擇目前帳號可存取的任意儲存庫，直接開始對話或任務。',
    remoteComposerDescription: '在上線的 jcode 裝置上使用相同的對話介面繼續工作。',
    contextAria: 'Repository 或 Remote 內容 {context}', repositoryFallback: 'Repository', remoteBack: '返回 Repositories', remoteConnection: '遠端連線',
    remoteChooseDevice: '選擇上線的 jcode 裝置', onlineDevices: '上線裝置', jcodeDevice: 'jcode 裝置', online: '上線',
    connectNewDevice: '連接新裝置', connectNewDeviceDescription: '執行 jcode login 並完成加密配對',
    pickerSearchAria: '搜尋 Repositories', pickerSearchPlaceholder: '搜尋 Repositories…', gitRepositories: 'Git 儲存庫',
    pickerSearchError: 'Repository 搜尋失敗，請修改關鍵字或重試。', pickerNoMatch: '沒有與「{query}」相符的 Repository。',
    remoteConnectionAria: '遠端連線，{count} 台上線', remoteOnlineCount: '{count} 台 jcode 裝置上線', searchingRepositories: '正在搜尋 Repositories',
    conversationRailAria: '對話', conversationRailWorkHome: '工作首頁', conversationRailNew: '新對話',
    conversationRailSearchAria: '搜尋對話', conversationRailSearchPlaceholder: '搜尋對話…', conversationRailByRepository: '最近儲存庫',
    conversationRailCollapse: '收合對話欄', conversationRailExpand: '展開對話欄', conversationRailEmptyTitle: '尚無對話',
    conversationRailEmptyDescription: '開始一個任務來建立第一則對話。', conversationRailNoMatch: '沒有符合搜尋的對話。', conversationRailRepositoryUnavailable: 'Repository 無法使用',
    workspaceTasks: '任務', workspaceBoard: '看板', workspaceReviews: '程式碼審查', workspaceAutomations: '自動化', workspaceUsage: '用量', workspaceSettings: '設定',
    cloudRunner: '雲端 Runner', noTasksTitle: '此 Repository 尚無任務', noTasksDescription: '在上方描述任務以開始第一個對話。',
    boardDescription: '連接現有 Board，讓 Card 啟動此 Repository 的 Agent。', reviewsDescription: '此 Repository 的獨立程式碼審查 Run。',
    reviewsEmptyDescription: '建立獨立審查，不與實作任務混在一起。', boardNotConnected: '尚未連接 Board',
    boardNotConnectedDescription: '準備好後連接現有 Board；Repository 工作區現在已可使用。', boardWorkflowAria: '預設 Agent Board 流程',
    boardBacklog: '待處理', boardBacklogDescription: '等待處理的 Card', boardAgentQueue: 'Agent 佇列', boardAgentQueueDescription: '會啟動 jcode 的 Card',
    boardDoneOptional: '完成（可選）', boardDoneDescription: '成功完成的結果',
    attachmentsAfterConversation: '此 Repository 建立活動對話後即可加入附件。', modeCeilingHint: 'Cloud 任務支援逐次確認、規劃和自動模式。',
    baseBranchAria: '基礎分支 {branch}', unavailable: '不可用', loadingBranches: '正在載入分支…', branchUnavailable: '分支不可用',
    startingRepositoryTask: '正在啟動 Repository 任務…', branchesUnavailable: 'Repository 分支不可用。', noToolModel: '帳號授權的模型都不支援 Agent 工具呼叫。',
    remoteSetup: 'Remote 設定', deviceOffline: '此裝置已離線。請在裝置上開啟 jcode 後重試。', startingConversation: '正在開始新對話',
    deviceSlow: '裝置回應時間比預期更長…', creatingOnDevice: '正在裝置上建立…',
    taskAria: '描述任務', taskPlaceholder: '描述一個任務…', repositoryAria: 'Repository',
    accountLoading: '正在載入儲存庫…', chooseAccountRepository: '選擇儲存庫',
    modelsLoading: '正在載入模型…', modelRequired: '選擇模型', startTask: '開始任務',
    startFailed: '無法開始任務。', accountLoadError: '無法載入帳號儲存庫，請重新連結程式碼託管帳號後再試。',
    linkAccount: '連結 Git 供應商帳號後即可選擇儲存庫。', reviewGitAccountAccess: '檢查 Git 帳號授權',
    authorizeModel: '請讓管理員為你的帳號授權一個模型。', reviewModelAccess: '檢查模型授權',
    detailsTitle: 'Repository 詳情', detailsDescription: '開啟已使用過的 Repository，查看設定、Agent Board 和任務記錄。',
    noDetails: '開始第一個任務後，這裡會出現 Repository 詳情；不需要預先連結。',
    connect: '連接 Repository', loading: '正在載入 Repositories…', loadError: '無法載入 Repositories',
    preparing: '正在準備 Repository 工作區…', prepareError: '無法準備 Repository 工作區',
    connectionsTitle: '供應商帳號', connectionsDescription: '管理帳號供應商與 JType 存取；Repository 不需要另行連接。',
    chooseRepository: '選擇 Repository',
    emptyEyebrow: '從程式碼開始', emptyTitle: '連接第一個 Repository',
    emptyBody: '選擇 Repository 以建立 Agent 工作區；個人工作區保持隱式。',
    listTitle: '已連接的 Repositories', visible: '個可見', search: '搜尋 Repositories',
    searchPlaceholder: '搜尋 owner 或 repository…', noMatch: '沒有符合的 Repository。',
    details: 'Repository 詳情', open: '開啟', codeReviews: '程式碼審查',
    loadingOne: '正在載入 Repository…', loadOneError: '無法載入 Repository', railAria: 'Repositories', noneConnected: '尚未連接 Repository。',
    workspaceAria: '{repositoryName} Repository 工作區', tabsAria: 'Repository 工作區區段', tabSettings: 'Repository 設定', connection: '供應商連接',
    connectionsIntro: '每個供應商只需為你的 Repositories 連接一次；健康的連接可供 Repository 任務使用。', connectionsReadOnly: '只有 Repository owner 或 Cluster 管理員可以變更供應商連接。',
    connectionSummary: '{repositories} 個 Repositories · {automations} 個自動化', providerRequired: '選擇 Repository 前，請先連接並啟用 GitHub、GitLab 或 Gitea 供應商。', configureConnections: '設定供應商連接',
    disconnect: '中斷 Repository', disconnectAria: '中斷 Repository {name}', disconnectConfirm: '中斷「{name}」？系統會先停止活動任務，再永久刪除該 Repository 的 Run、事件、產物、自動化與工作區資源。此操作無法復原。', disconnected: '已中斷 Repository「{name}」。', disconnectFailed: '無法中斷 Repository。',
    consentIntro: '繼續前往 {provider} 前，請確認此連接授予 jcode Cloud 的帳號級存取權。', consentShared: '權杖會成為你的 Repositories 共用憑據，而不是安裝者的個人憑據。', consentTasks: '你的 Repository 任務可使用每個已啟用的供應商連接，包括此連接。', consentPersistence: '此連接會持續存在，直到被中斷或由供應商撤銷。', consentPublic: '在公開儲存庫中，一則 @jcode 留言可以使用已啟用的供應商憑據啟動任務。', consentAcknowledge: '我理解並同意此帳號級 Repository 存取權。',
  },
  projects: {
    noServicesConnected: '尚未連接任何服務',
    serviceCount_one: '{count} 個服務',
    serviceCount_other: '{count} 個服務',
    eyebrow: '你的工作區',
    title: '專案',
    description: '專案會將交付某個產品所需的人員、服務、模型存取與自動化政策集結在一起。',
    newProject: '新增專案',
    loadingProjects: '正在載入專案…',
    loadError: '無法載入專案',
    empty: {
      eyebrow: '從邊界開始',
      title: '尚無專案。',
      body: '建立第一個專案作為空的容器。下一個畫面讓你將儲存庫授權為服務，而不會假裝尚未可用的供應商已連接。',
      cta: '建立第一個專案',
    },
    listTitle: '所有專案',
    visible: '可見',
    searchProjects: '搜尋專案',
    searchPlaceholder: '搜尋名稱或服務…',
    updatedJustNow: '剛剛更新',
    searchEmptyTitle: '沒有符合的專案。',
    searchEmptyBody: '試試專案、服務或儲存庫名稱。',
    createdAt: '建立於 {time}',
    openWorkspace: '開啟工作區',
    guide: {
      eyebrow: '專案的運作方式',
      title: '讓擁有權維持廣泛，讓執行維持明確。',
      body: '專案是長期存在的邊界；每個儲存庫都成為擁有自身模型與自動化連接設定的服務。',
      step1Title: '建立邊界',
      step1Desc: '為產品或團隊命名。',
      step2Title: '新增服務',
      step2Desc: '明確授權儲存庫。',
      step3Title: '開始工作',
      step3Desc: '僅在相依項就緒之後。',
    },
    create: {
      nameRequired: '名稱為必填。',
      created: '已建立專案「{name}」。',
      createFailed: '無法建立專案。',
      submit: '建立專案',
      nameLabel: '名稱',
      namePlaceholder: 'demo',
      nameHint: '接下來你會在專案頁面新增儲存庫。',
    },
    new: {
      nameRequired: '名稱為必填。',
      created: '已建立專案。',
      createFailed: '無法建立專案。',
      heading: '建立專案',
      subheading: '從擁有權邊界開始。服務隨後再加入。',
      draft: '草稿',
      step1Eyebrow: '01 / 識別',
      section1Title: '專案詳情',
      section1Body: '使用大家能辨識的產品或團隊邊界。',
      nameLabel: '名稱',
      namePlaceholder: '例如：jcode Cloud',
      nameHint: '你之後可以重新命名專案，而不會變更服務 URL。',
      step2Eyebrow: '02 / 邊界',
      section2Title: '這裡包含什麼',
      section2Body: '儲存庫會在建立後以服務的形式新增。',
      calloutStrong: '尚未建立或連接任何儲存庫。',
      calloutBody: '產生的工作區會以空白狀態開啟，由擁有者在其中明確授權每個服務。',
      submit: '建立專案',
      asideEyebrow: '建立之後',
      asideTitle: '工作區會以空白狀態開啟。',
      asideBody: '這讓專案建立保持誠實：即使尚無可用的 Git 供應商或模型，容器仍可存在。',
      asideItem1: '將儲存庫連接為服務。',
      asideItem2: '檢視 Cluster 管理員授權的模型。',
      asideItem3: '僅在所需相依項設定完成後才開始工作。',
    },
  },

  usage: {
    title: '用量',
    disclaimer: '用量是營運遙測，不是供應商帳單。',
    accountTitle: '雲端模型用量',
    accountDescription: '此帳號下裝置產生的模型用量。',
    proxyOnly: '僅包含透過 Cloud Model Proxy 傳送的請求。',
    unavailable: '不可用',
    reasonNotReported: '提供商沒有回報這次請求的用量。',
    reasonNoRequests: '此時間範圍內沒有產生用量的請求。',
    reasonParseError: 'Cloud 無法解析提供商的用量資料。',
    input: '輸入',
    output: '輸出',
    cacheRead: '快取讀取',
    cacheWrite: '快取寫入',
    captured: '已擷取 {captured} / {requests}',
    captureReported: '已回報',
    captureIncomplete: '擷取不完整',
    reported: '提供商回報',
    estimated: '估算',
    uncosted: '未計價',
    details: '定價與擷取詳情',
    requests: '請求數',
    reportedCapture: '完整擷取',
    partialCapture: '部分擷取',
    unavailableCapture: '不可用',
    parseErrors: '解析錯誤',
    pricingRevisions: '定價版本',
    none: '無',
    pricing: '定價',
    pricingTitle: '{model} 定價',
    pricingImmutable: '定價版本不可修改。需要變更時請新增一個帶生效時間的版本。',
    addPricingRevision: '新增版本',
    currency: '幣種',
    effectiveAt: '生效時間',
    inputRate: '輸入 / 百萬 token',
    outputRate: '輸出 / 百萬 token',
    cacheReadRate: '快取讀取 / 百萬 token',
    cacheWriteRate: '快取寫入 / 百萬 token',
    pricingHistory: '版本歷史',
    loadingPricing: '正在載入定價…',
    pricingLoadError: '無法載入定價',
    noPricingRevisions: '還沒有定價版本。除非提供商回報費用，否則用量會保持「未計價」。',
    pricingValidation: '請填寫有效幣種、生效時間，以及至少一個非負費率。',
    pricingCreateError: '無法建立定價版本',
    loading: '正在載入用量…',
    loadError: '無法載入用量',
    groupBy: '分組方式',
    group: { service: '儲存庫', automation: '自動化', model: '模型', device: '裝置', grant: '授權範圍' },
    range: '時間範圍',
    range24h: '24 小時',
    range7: '7 天',
    range30: '30 天',
    range90: '90 天',
    windowNote: '顯示 {timeZone} 時區下的 {range}。彙總採用 UTC 小時桶。',
    captureHealth: '擷取健康度',
    costSources: '成本來源',
    reportedHelp: '由提供商回報，絕不與 Cloud 估算值合併。',
    estimatedHelp: '根據不可變的定價版本計算。',
    uncostedHelp: '沒有適用類別費率的 token。',
    groupedUsage: '按{group}查看用量',
    noGroups: '此時間範圍內沒有可歸屬的用量。',
    category: {
      input: '輸入',
      output: '輸出',
      cache_read: '快取讀取',
      cache_write: '快取寫入',
    },
  },
  runDetail: {
    loadingRun: '正在載入執行…',
    loadRunError: '無法載入執行',
    loadingWorkspace: '正在載入專案工作區…',
    projectName: '專案 {id}',
    nav: {
      projects: '專案',
      repositories: '儲存庫',
    },
    railFooter: '專案工作區',
    repositoryWorkspace: '儲存庫工作區',
    breadcrumbLabel: '麵包屑導覽',
    breadcrumb: {
      tasks: '工作',
      detail: '詳情',
    },
    recentTasks: '最近的工作',
    serviceUnavailable: '儲存庫無法使用',
    repositoryUnavailable: '儲存庫無法使用',
    noChangesBadge: '無變更',
    action: {
      stop: '停止',
      retry: '重試',
      retryOtherModel: '切換模型',
      conversation: '對話',
    },
    retryModel: {
      title: '切換其他模型重試',
      description: '使用其他模型建立一次新的嘗試。工作流程、程式碼版本、權限和交付契約保持不變。',
      current: '目前模型',
      choose: '選擇其他帳號模型',
      unknown: '未知模型',
      confirm: '切換模型並重試',
	  originalUnavailable: '原模型已無法使用。請選擇其他帳號模型。',
    },
    you: '你',
    reviewInProgress: '審查進行中…',
    reviewFailed: '此審查失敗，因此未產生輸出。',
    noReviewOutput: '未產生任何審查輸出。',
    noEvents: '未記錄任何對話事件。',
    waitingForAgent: '正在等待 agent…',
    streamDisconnected: '即時更新已中斷。改為顯示定期重新整理。',
    reconnect: '重新連線',
    refreshError: '無法重新整理最新的執行詳情 — 顯示最後已知的狀態。',
    modelLabel: '模型',
    toast: {
      permissionDecisionFailed: '無法傳送權限決定。',
      messageFailed: '無法傳送訊息。',
      sessionResumed: '工作階段已恢復。',
      resumeFailed: '無法恢復工作階段。',
      canceled: '已取消執行。',
      cancelFailed: '取消失敗。',
      retryDispatched: '已派發重試。',
      retryFailed: '重試失敗。',
      sessionFinishing: '工作階段即將結束 — agent 正在收尾。',
      finishFailed: '無法結束工作階段。',
    },
    failure: {
      cloneFailed: '儲存庫複製失敗',
      setupFailed: '專案設定失敗',
      agentError: 'Agent 錯誤',
      modelRateLimited: '模型觸發限流',
      timeout: '已逾時',
      pushFailed: '分支推送失敗',
      runFailed: '執行失敗',
      noMessage: '執行失敗，且未附帶訊息。',
    },
    kind: {
      codeReview: '程式碼審查',
      session: '工作階段',
      automatedTask: '自動工作',
      manualTask: '手動工作',
    },
    originLabel: {
      webhook: '供應商 Webhook',
      schedule: '排程',
      kanban: 'Kanban',
      prEvent: 'PR 事件',
      manual: '手動',
    },
    session: {
      sessionQueued: '工作階段已排入佇列 — 正在等待空閒並行名額。',
      sessionStarting: '工作階段啟動中 — 正在排程工作區。',
      sessionActionsHint: '「結束」會讓 agent 在目前回合後收尾；「取消」會立即停止。',
      finishSession: '結束工作階段',
      resumeHint: '繼續此工作階段 — agent 會保留相同的上下文。',
    },
    composer: {
      continuePlaceholder: '繼續此工作…',
      followUpPlaceholder: '排入後續訊息 — 它會在目前回合後執行…',
      serviceDefault: '儲存庫預設值',
      useServiceModel: '使用儲存庫設定的模型',
      modelFixed: '此使用中工作階段的模型已固定',
      messageInput: '訊息輸入',
      attachmentsUnavailableTitle: 'Cloud 工作階段尚不支援附件。',
      attachmentsUnavailable: '附件無法使用',
      modelAccessLocked: '模型與存取權會在你恢復時套用。',
      modeCeilingHint: 'Cloud 工作階段支援逐次確認、規劃和自動模式。',
      queue: '排入佇列',
      send: '傳送',
      sendMessage: '傳送訊息',
    },
    model: {
      disabledTitle: '使用中的 agent 工作階段會保留其現有的模型。',
      chooseTitle: '為恢復的工作階段選擇模型。',
      filterModels: '篩選模型',
      filterModelsPlaceholder: '篩選模型…',
      modelsHeading: '模型',
      noMatchingModels: '沒有符合的模型',
    },
    permission: {
      askForApproval: '請求核准',
      askForApprovalSub: 'agent 在執行工具前會先詢問',
      plan: '計劃',
      planSub: 'Cloud 工作階段尚不支援',
      fullAccess: '完全存取',
      fullAccessSub: 'agent 無需詢問即可操作',
      permissionMode: '權限模式',
      disabledTitle: '使用中的 agent 工作階段會保留其現有的權限模式。',
      chooseTitle: '選擇恢復的 agent 如何請求權限。',
    },
    inspector: {
      runDetailsLabel: '執行詳情',
      identityAndSource: '身分與來源',
      requestedBy: '請求者',
      accountableTo: '責任人',
      triggeredFrom: '觸發來源',
      executedFor: '執行對象',
      project: '專案',
      repository: '程式碼倉庫',
      dispatchSnapshot: '調度時快照',
      writtenBackAs: '回寫身分',
      externalActor: '外部身分',
      ruleOwner: '規則負責人',
      botOrApp: 'Bot / 應用程式',
      notAttributed: '無法歸屬',
      notApplicable: '不適用',
      technicalIdentity: '技術身分',
      runtimePrincipal: '執行主體',
      attribution: '歸屬精度',
      source: '來源',
      precisionExact: '精確',
      precisionLinkedExternal: '已連結外部身分',
      precisionRuleOwner: '歸屬到規則負責人',
      precisionUnattributed: '無法歸屬',
      runOverview: '執行總覽',
      service: '服務',
      unavailable: '無法使用',
      trigger: '觸發',
      notReported: '未回報',
      permission: '權限',
      askBeforeActions: '動作前詢問',
      workspace: '工作區',
      changes: '變更',
      noCodeChanges: '無程式碼變更',
      reviewPatch: '檢視完整修補檔',
      loadingChangeSummary: '正在載入變更摘要…',
      diffUnavailable: 'diff 無法使用',
      diffAfterAgent: '在 agent 產生 diff 後即可使用',
      viewCompleteDiff: '檢視完整 diff',
      openPrDetails: '開啟 pull request 詳情',
      draftPr: '草稿 PR',
	  executionStatus: '執行狀態',
	  deliveryStatus: '交付狀態',
	  deliveryKind: '交付目標',
	  deliveryIssue: '交付問題',
	  deliveryUnknown: '未回報',
	  delivery: { not_required: '無需交付', pending: '交付中', delivered: '已交付', failed: '交付失敗' },
	  deliveryKindLabel: { artifact: '產物', pull_request: '拉取請求', branch_update: '分支更新', review_comment: 'Review 評論' },
      execution: '執行',
      started: '已開始',
      notStarted: '尚未開始',
      duration: '耗時',
      runId: '執行 ID',
      retryOf: '重試自',
      resumedFrom: '恢復自',
      resumedFromLink: '恢復自 {id}',
    },
    origin: {
      fromPrComment: '來自 PR 留言',
      scheduled: '已排程',
      kanbanAutomation: 'Kanban 自動化',
      prEventAutomation: 'PR 事件自動化',
    },
    diff: {
      runFailedNoDiff: '此執行失敗，因此未產生 diff。',
      diffAfterArtifact: '在 agent 產生產物後即可取得 diff。',
      noCodeChanges: '此執行未變更任何程式碼。',
      loadingDiff: '正在載入 diff…',
      loadDiffError: '無法載入 diff',
    },
    failedSubmission: {
      notSent: '訊息未傳送。',
      draftPreserved: '你的草稿已保留。',
      retryUnsent: '重試未傳送的訊息',
    },
  },
};
